const ro = {
  'common.loading': 'Se încarcă…',
  'common.save': 'Salvează',
  'common.cancel': 'Anulează',
  'common.delete': 'Șterge',
  'common.search': 'Caută',
  'common.accessDenied': 'Acces refuzat',
  'common.backToLogin': 'Înapoi la autentificare',
  'common.markAsRead': 'Marchează ca citit',
  'shell.supportDesk': 'Centrul de asistență',
  'shell.searchPlaceholder': 'Caută tichete, contacte, articole…',
  'shell.newTicket': 'Tichet nou',
  'shell.notifications': 'Notificări',
  'shell.notificationPreferences': 'Preferințe notificări',
  'shell.settings': 'Setări',
  'shell.signOut': 'Deconectare',
  'shell.expandNavigation': 'Extinde navigarea',
  'shell.collapseNavigation': 'Restrânge navigarea',
  'shell.caughtUp': 'Totul este la zi',
  'shell.viewAllNotifications': 'Vezi toate notificările',
  'nav.dashboard': 'Panou de control',
  'nav.tickets': 'Tichete',
  'nav.contacts': 'Contacte',
  'nav.companies': 'Companii',
  'nav.reports': 'Rapoarte',
  'nav.settings': 'Setări',
  'nav.agents': 'Agenți',
  'nav.groups': 'Grupuri',
  'nav.roles': 'Roluri',
  'nav.tags': 'Etichete',
  'nav.ticketFields': 'Câmpuri tichet',
  'nav.ticketForms': 'Formulare tichet',
  'nav.businessHours': 'Program de lucru',
  'nav.slaPolicies': 'Politici SLA',
  'nav.automations': 'Automatizări',
  'nav.email': 'E-mail',
  'nav.notificationTemplates': 'Șabloane notificări',
  'nav.apiKeys': 'Chei API',
  'nav.cannedResponses': 'Răspunsuri predefinite',
  'nav.knowledgeBase': 'Bază de cunoștințe',
  'auth.signInTitle': 'Centrul de asistență SDPL',
  'auth.signInSubtitle': 'Autentifică-te în contul tău',
  'auth.emailAddress': 'Adresă de e-mail',
  'auth.password': 'Parolă',
  'auth.signingIn': 'Se autentifică…',
  'auth.signIn': 'Autentificare',
  'auth.forgotPassword': 'Ai uitat parola?',
  'auth.twoFactor': 'Autentificare cu doi factori',
  'auth.verificationCode': 'Cod de verificare',
  'auth.verify': 'Verifică',
  'auth.backToLogin': 'Înapoi la autentificare',
  'agents.title': 'Agenți',
  'agents.new': 'Agent nou',
  'agents.supportAgents': 'Agenți de asistență',
  'agents.collaborators': 'Colaboratori',
  'agents.deactivated': 'Dezactivați',
  'agents.searchPlaceholder': 'Caută după nume sau e-mail',
  'agents.edit': 'Editează',
  'agents.deactivate': 'Dezactivează',
  'agents.reactivate': 'Reactivează',
  'agents.saved': 'Agent salvat.',
  'agents.firstName': 'Prenume',
  'agents.lastName': 'Nume',
  'agents.email': 'E-mail',
  'agents.phone': 'Telefon',
  'agents.timezone': 'Fus orar',
  'agents.selectTimezone': 'Selectează fusul orar',
  'agents.language': 'Limbă',
  'agents.selectLanguage': 'Selectează limba',
  'agents.emailSignature': 'Semnătură e-mail',
  'agents.roleRequired': 'Rol',
  'agents.selectRole': 'Selectează rolul',
  'agents.status': 'Stare',
  'agents.groupsTitle': 'Grupuri',
  'agents.manageGroups': 'Gestionează grupurile',
  'agents.notInGroup': 'Nu este încă într-un grup',
  'dashboard.title': 'Panou de control',
  'dashboard.description': 'Volumul actual de lucru al asistenței și starea serviciului.',
  'dashboard.allGroups': 'Toate grupurile accesibile',
  'dashboard.unresolved': 'Nerezolvate',
  'dashboard.overdue': 'Depășite',
  'dashboard.dueToday': 'Scad astăzi',
  'dashboard.open': 'Deschise',
  'dashboard.onHold': 'În așteptare',
  'dashboard.unassigned': 'Nealocate',
  'dashboard.trends': 'Tendințele de astăzi',
  'notifications.title': 'Notificări',
  'notifications.description': 'Istoricul complet al notificărilor tale.',
  'notifications.markAllRead': 'Marchează totul ca citit',
  'notifications.filter': 'Filtru',
  'notifications.allTypes': 'Toate tipurile',
  'notifications.none': 'Nu există încă notificări',
  'notifications.assigned': 'Alocat',
  'notifications.reply': 'Răspuns',
  'notifications.note': 'Notă',
  'notifications.slaWarning': 'Avertizare SLA',
  'notifications.slaBreach': 'Încălcare SLA',
  'notifications.slaEscalation': 'Escaladare SLA',
  'notifications.mention': 'Mențiune',
  'preferences.title': 'Preferințe notificări',
  'preferences.description': 'Notificările din aplicație rămân active. Alege care dintre ele trimit și un e-mail.',
  'preferences.emailDigest': 'Rezumat e-mail',
  'preferences.dailySummary': 'Primește un singur e-mail cu rezumatul zilnic în locul unui e-mail pentru fiecare eveniment.',
  'preferences.digestOff': 'Dezactivat — e-mail pentru fiecare eveniment',
  'preferences.digestDaily': 'Rezumat zilnic',
  'preferences.emailNotifications': 'Notificări prin e-mail',
  'activities.button': 'Activități recente',
  'activities.title': 'Activități recente',
  'activities.loadError': 'Activitățile recente nu au putut fi încărcate.',
  'activities.systemActor': 'Sistem',
  'activities.noneTitle': 'Nu există încă activitate recentă',
  'activities.noneDescription': 'Actualizările de tichete de la dvs. și grupul dvs. vor apărea aici pe măsură ce se produc.',
  'tickets.title': 'Tichete',
  'tickets.description': 'Toate tichetele la care aveți acces, filtrate și sortate după cum lucrați.',
  'tickets.dueDateTabs': 'Data scadentă a tichetului',
  'tickets.tabAll': 'Toate tichetele',
  'tickets.tabDueToday': 'Scadente astăzi',
  'tickets.tabOverdue': 'Întârziate',
  'tickets.tabDueTomorrow': 'Scadente mâine',
  'tickets.searchPlaceholder': 'Căutați tichete…',
  'tickets.searchAria': 'Căutați tichete',
  'tickets.filters': 'Filtre',
  'tickets.filtersWithCount': 'Filtre ({count})',
  'tickets.sortAria': 'Sortați tichetele după',
  'tickets.sortTrigger': 'Sortare: {label}',
  'tickets.sortDateCreated': 'Data creării',
  'tickets.sortDateUpdated': 'Data actualizării',
  'tickets.sortPriority': 'Prioritate',
  'tickets.sortStatus': 'Stare',
  'tickets.sortDueDate': 'Data scadentă',
  'tickets.sortAscending': 'Sortare crescătoare',
  'tickets.sortDescending': 'Sortare descrescătoare',
  'tickets.ascending': 'Crescător',
  'tickets.descending': 'Descrescător',
  'tickets.layoutAria': 'Aspect rânduri',
  'tickets.layoutTrigger': 'Aspect: {label}',
  'tickets.layoutCard': 'Card',
  'tickets.layoutInbox': 'Mesaje primite',
  'tickets.layoutTable': 'Tabel',
  'tickets.export': 'Exportă',
  'tickets.exportSelected': 'Exportă selecția',
  'tickets.selectedCount': '{count} selectate',
  'tickets.assignAgent': 'Alocă agent',
  'tickets.closeAll': 'Închide toate',
  'tickets.clearSelection': 'Anulează selecția',
  'tickets.selectAgentPlaceholder': 'Selectați agent...',
  'tickets.assignTo': 'Alocă lui',
  'tickets.assign': 'Alocă',
  'tickets.loadFailed': 'Tichetele nu au putut fi încărcate. Încercați din nou.',
  'tickets.bulkCloseFailed': 'Tichetele selectate nu au putut fi închise. Încercați din nou.',
  'tickets.bulkAssignFailed': 'Tichetele selectate nu au putut fi alocate. Încercați din nou.',
  'tickets.noFilterMatchTitle': 'Niciun tichet nu corespunde acestor filtre',
  'tickets.noFilterMatchDescription': 'Încercați să eliminați un filtru, să extindeți intervalul de date sau să căutați un alt termen.',
  'tickets.clearFilters': 'Șterge filtrele',
  'tickets.queueClearTitle': 'Această coadă este liberă',
  'tickets.queueClearDescription': 'Tichetele noi vor apărea aici pe măsură ce clienții trimit e-mail, folosesc portalul sau un agent creează unul.',
  'tickets.newTicket': 'Tichet nou',
  'tickets.selectAllAria': 'Selectați toate tichetele',
  'tickets.selectTicketAria': 'Selectați tichetul nr. {number}',
  'tickets.columnContact': 'Contact',
  'tickets.columnSubject': 'Subiect',
  'tickets.columnState': 'Stare',
  'tickets.columnGroup': 'Grup',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Prioritate',
  'tickets.noGroup': 'Niciun grup',
  'tickets.unassigned': 'Nealocat',
  'tickets.createdRelative': 'Creat {when}',
  'tickets.unassignedOnly': 'Doar nealocate',
  'tickets.unknownRequester': 'Solicitant necunoscut',
  'tickets.overdueBy': 'Întârziat cu {duration}',
  'tickets.dueIn': 'Scadent în {duration}',
  'tickets.filtersDrawerTitle': 'Filtre',
  'tickets.filtersSearchPlaceholder': 'Căutați câmpuri',
  'tickets.filtersSearchAria': 'Căutați câmpuri de filtrare',
  'tickets.filtersClearAll': 'Șterge tot',
  'tickets.filtersApply': 'Aplică',
  'tickets.filterAgents': 'Agenți',
  'tickets.filterAnyAgent': 'Orice agent',
  'tickets.filterGroups': 'Grupuri',
  'tickets.filterAnyGroup': 'Orice grup',
  'tickets.filterStatus': 'Stare',
  'tickets.filterAnyStatus': 'Orice stare',
  'tickets.filterPriority': 'Prioritate',
  'tickets.filterAnyPriority': 'Orice prioritate',
  'tickets.filterSource': 'Sursă',
  'tickets.filterAnySource': 'Orice sursă',
  'tickets.filterTicketType': 'Tip tichet',
  'tickets.filterAnyType': 'Orice tip',
  'tickets.filterTags': 'Etichete',
  'tickets.filterAnyTag': 'Orice etichetă',
  'tickets.filterCompanies': 'Companii',
  'tickets.filterAnyCompany': 'Orice companie',
  'tickets.filterCreated': 'Creat',
  'tickets.filterResolvedAt': 'Rezolvat la',
  'tickets.filterClosedAt': 'Închis la',
  'tickets.filterDateFrom': '{label} de la',
  'tickets.filterDateTo': '{label} până la',
  'tickets.filterDateTo2': 'până la',
  'tickets.filterAny': 'Orice',
  'tickets.chipFieldStatus': 'Stare',
  'tickets.chipFieldPriority': 'Prioritate',
  'tickets.chipFieldGroup': 'Grup',
  'tickets.chipFieldAssignee': 'Responsabil',
  'tickets.chipValueGroup': 'Grup',
  'tickets.chipValueUnassigned': 'Nealocat',
  'common.saving': 'Se salvează…',
  'common.clearSearch': 'Șterge căutarea',
  'common.sortBy': 'Sortează după',
  'common.name': 'Nume',
  'common.role': 'Rol',
  'common.groups': 'Grupuri',
  'common.tickets': 'Tichete',
  'common.lastSeen': 'Ultima activitate',
  'common.actions': 'Acțiuni',
  'common.never': 'Niciodată',
  'common.justNow': 'Chiar acum',
  'common.minutesAgo': 'acum {count} min',
  'common.hoursAgo': 'acum {count} h',
  'common.daysAgo': 'acum {count} z',
  'common.noPagePermission': 'Nu aveți permisiunea de a accesa această pagină.',
  'common.roleNoPermission': 'Rolul dvs. nu are permisiunea de a accesa această pagină.',
  'common.requestFailed': 'Cererea a eșuat. Încercați din nou.',
  'common.unexpectedError': 'A apărut o eroare neașteptată',
  'common.user': 'Utilizator',
  'shell.skipToMain': 'Salt la conținutul principal',
  'shell.homeLabel': 'Pagina principală Suzuki Support Desk',
  'shell.userMenu': 'Meniu utilizator',
  'shell.unread': '{count} necitite',
  'shell.adminNavigation': 'Navigare administrare',
  'shell.notificationDescription': 'Alocările, răspunsurile și alertele SLA noi vor apărea aici.',
  'auth.enterAuthenticatorCode': 'Introduceți codul din 6 cifre din aplicația de autentificare',
  'auth.verifying': 'Se verifică…',
  'auth.setupAuthenticator': 'Configurează autentificatorul',
  'auth.scanAuthenticator': 'Scanați acest cod cu aplicația de autentificare (Google Authenticator, Authy etc.)',
  'auth.authenticatorSetupQr': 'Cod QR pentru configurarea autentificatorului',
  'auth.verificationCodeFromAuthenticator': 'Cod de verificare din autentificator',
  'auth.verifyAndComplete': 'Verifică și finalizează configurarea',
  'auth.loadingSetup': 'Se încarcă configurarea…',
  'auth.setNewPassword': 'Setează o parolă nouă',
  'auth.temporaryPasswordExpired': 'Parola temporară a expirat. Setați o parolă nouă.',
  'auth.newPassword': 'Parolă nouă',
  'auth.confirmPassword': 'Confirmă parola',
  'auth.settingPassword': 'Se setează parola…',
  'auth.setPassword': 'Setează parola',
  'auth.passwordRequirements': 'Sunt necesare cel puțin 8 caractere, majusculă, minusculă, cifră și simbol',
  'auth.tooManyAttempts': 'Prea multe încercări de conectare. Încercați din nou mai târziu.',
  'auth.invalidCredentials': 'E-mail sau parolă invalidă',
  'auth.passwordsDoNotMatch': 'Parolele nu coincid',
  'auth.passwordMinimum': 'Parola trebuie să aibă cel puțin {count} caractere',
  'auth.resetTitle': 'Resetați parola',
  'auth.resetSubtitle': 'Introduceți e-mailul și vă vom trimite un link de resetare',
  'auth.checkEmail': 'Verificați e-mailul pentru linkul de resetare',
  'auth.checkCode': 'Verificați e-mailul pentru codul de verificare, apoi continuați mai jos.',
  'auth.continueToReset': 'Continuați pentru resetarea parolei',
  'auth.sendResetLink': 'Trimite linkul de resetare',
  'auth.sending': 'Se trimite…',
  'auth.resetSuccess': 'Parola a fost resetată cu succes.',
  'auth.goToLogin': 'Du-te la autentificare',
  'auth.missingResetToken': 'Token de resetare lipsă. Utilizați linkul din e-mail.',
  'auth.enterCodeFromEmail': 'Introduceți codul de verificare trimis pe e-mail',
  'auth.codeFromEmail': 'Introduceți codul din e-mail',
  'auth.emailRequired': 'E-mailul este obligatoriu',
  'auth.codeRequired': 'Codul de verificare este obligatoriu',
  'auth.missingToken': 'Token de resetare lipsă',
  'auth.failedReset': 'Resetarea parolei a eșuat.',
  'auth.resetting': 'Se resetează…',
  'auth.resetPassword': 'Resetează parola',
  'auth.looksGood': 'Pare în regulă',
  'auth.needCharacters': 'Este necesar cel puțin {count} caractere',
  'auth.passwordFormat': 'Sunt necesare cel puțin {count} caractere, majusculă, minusculă, cifră și simbol',
  'agents.description': 'Persoanele care lucrează la tichete. Alocați un rol pentru a controla ce pot face și grupuri pentru a controla ce văd.',
  'agents.searchAria': 'Căutați agenți',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agenți',
  'agents.ticketOne': '{count} tichet',
  'agents.ticketMany': '{count} tichete',
  'agents.noGroups': 'Niciun grup',
  'agents.lifecycle': 'Ciclul de viață al agentului',
  'agents.noSearchResults': 'Niciun agent nu corespunde acestei căutări',
  'agents.noAgentsView': 'Niciun agent în această vizualizare',
  'agents.tryDifferent': 'Încercați un alt nume sau altă adresă de e-mail.',
  'agents.useNewAgent': 'Utilizați Agent nou pentru a adăuga pe cineva, sau schimbați fila pentru a vedea alți agenți.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Niciun rol',
  'agents.openTicketsTitle': 'Tichete deschise alocate în prezent acestui agent',
  'agents.moreActions': 'Mai multe acțiuni pentru {name}',
  'agents.confirmDeleteTitle': 'Ștergeți {name}?',
  'agents.confirmDeleteDescription': 'Această acțiune nu poate fi anulată. Agenții asociați tichetelor nu pot fi șterși; dezactivați-i în schimb.',
  'agents.confirmDeleteLabel': 'Șterge agentul',
  'agents.agentsVsCollaborators': 'Agenți vs. colaboratori',
  'agents.agentsVsCollaboratorsBody': 'Agenții de asistență lucrează la tichete zilnic. Colaboratorii au un rol de colaborator și sunt de obicei experți implicați pe tichete individuale fără acces complet de agent.',
  'agents.deactivateVsDelete': 'Dezactivare vs. ștergere',
  'agents.deactivateVsDeleteBody': 'Dezactivarea păstrează istoricul și proprietatea tichetelor, dar blochează autentificarea. Ștergerea este permanentă și funcționează doar când agentul nu are tichete asociate.',
  'agents.newTitle': 'Agent nou',
  'agents.editTitle': 'Editează agentul',
  'agents.temporaryPassword': 'Parolă temporară',
  'agents.passwordHelp': 'Cel puțin 12 caractere. Agentul o poate schimba după autentificare.',
  'agents.timezoneHelp': 'Fiecare dată și oră văzută de acest agent este afișată în acest fus orar.',
  'agents.languageHelp': 'Traduce interfața orientată către agent. Răspunsurile la tichete și conținutul clientului nu sunt traduse.',
  'agents.signaturePlaceholder': 'Adăugată la răspunsurile trimise',
  'agents.roleHelp': 'Determină ce poate face acest agent.',
  'agents.manageRoles': 'Gestionează rolurile',
  'agents.activeHelp': 'Activ — debifarea blochează autentificarea fără a șterge agentul',
  'agents.groupHelp': 'Adăugați acest agent la un grup din ecranul Grupuri pentru a controla ce tichete vede.',
  'agents.about': 'Despre acest agent',
  'agents.aboutBody': 'Numele, e-mailul, telefonul, fusul orar, limba și semnătura identifică agentul și personalizează spațiul de lucru al acestuia. Rolul controlează ce poate face; apartenența la grup controlează ce tichete vede.',
  'dashboard.trendsDescription': 'Crearea tichetelor pe oră UTC, comparativ cu ziua de ieri.',
  'dashboard.today': 'Astăzi',
  'dashboard.yesterday': 'Ieri',
  'dashboard.chartAria': 'Volumul tichetelor pe oră UTC, astăzi față de ieri',
  'dashboard.dataUnavailable': 'Datele panoului de control nu sunt disponibile.',
  'dashboard.loadError': 'Nu s-au putut încărca datele panoului de control. Încercați din nou.',
  'notifications.noType': 'Nu există notificări de acest tip',
  'notifications.allTypesHint': 'Alegeți „Toate tipurile” de mai sus pentru a vedea restul istoricului.',
  'notifications.emptyDescription': 'Alocările, răspunsurile și alertele SLA apar aici. Ajustați care dintre acestea vă trimit și e-mail în preferințele de notificări.',
  'preferences.digestWarning': 'Utilizați rezumatul zilnic, astfel încât aceste setări sunt ignorate până când îl dezactivați.',
  'preferences.assignedEvent': 'Vă este alocat un tichet',
  'preferences.replyEvent': 'Un tichet din care faceți parte primește un răspuns',
  'preferences.noteEvent': 'Se adaugă o notă privată',
  'preferences.slaWarningEvent': 'SLA se apropie de termenul limită',
  'preferences.slaBreachEvent': 'SLA este încălcat',
  'preferences.slaEscalationEvent': 'SLA escaladează peste termenul limită',
  'preferences.mentionEvent': 'Sunteți menționat pe un tichet',

  'ticketDetail.back': 'Înapoi',
  'ticketDetail.follow': 'Urmărește',
  'ticketDetail.following': 'Urmărit',
  'ticketDetail.hideActivities': 'Ascunde activitățile',
  'ticketDetail.activitiesButton': 'Activități',
  'ticketDetail.attachmentsCount': 'Fișiere atașate ({count})',
  'ticketDetail.threadAria': 'Fir tichet',
  'ticketDetail.conversationsTabLabel': 'Conversații',
  'ticketDetail.activitiesTabLabel': 'Activități',
  'ticketDetail.noRepliesYet': 'Niciun răspuns încă',
  'ticketDetail.noRepliesDescription': 'Utilizați editorul de mai jos pentru a răspunde solicitantului sau a adăuga o notă internă.',
  'ticketDetail.privateNote': 'Notă privată',
  'ticketDetail.forward': 'Redirecționat',
  'ticketDetail.uploadingAria': 'Se încarcă',
  'ticketDetail.uploadingProgress': 'Se încarcă {uploading} din {total} fișier(e)…',
  'ticketDetail.uploadsFailed': '{count} încărcare(ări) nereușită(e)',
  'ticketDetail.retry': 'Încearcă din nou',
  'ticketDetail.dismiss': 'Renunță',
  'ticketDetail.noActivityYet': 'Nicio activitate încă',
  'ticketDetail.noActivityDescription': 'Modificările de stare, agent și SLA vor fi listate aici pe măsură ce tichetul avansează.',
  'ticketDetail.requester': 'Solicitant',
  'ticketDetail.properties': 'Proprietăți',
  'ticketDetail.updating': 'Se actualizează…',
  'ticketDetail.update': 'Actualizează',
  'ticketDetail.tags': 'Etichete',
  'ticketDetail.relationships': 'Relații',
  'ticketDetail.parentTicket': 'Tichet părinte',
  'ticketDetail.unlink': 'Anulează legătura',
  'ticketDetail.noParentTicket': 'Niciun tichet părinte',
  'ticketDetail.childTicketsCount': 'Tichete subordonate ({count})',
  'ticketDetail.noChildTickets': 'Niciun tichet subordonat',
  'ticketDetail.findTicket': 'Găsește un tichet',
  'ticketDetail.ticketSearchPlaceholder': 'Numărul tichetului sau subiect',
  'ticketDetail.searchButton': 'Căutare',
  'ticketDetail.setParent': 'Setează ca părinte',
  'ticketDetail.mergeIntoAction': 'Fuzionează cu',
  'ticketDetail.splitIntoChild': 'Divide într-un tichet subordonat',
  'ticketDetail.newTicketSubjectPlaceholder': 'Subiectul noului tichet',
  'ticketDetail.splitButton': 'Divide',
  'ticketDetail.copyAttachments': 'Copiază fișierele atașate',
  'ticketDetail.copyConversationHistory': 'Copiază istoricul conversației',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Întrerupt',
  'ticketDetail.editButton': 'Editează',
  'ticketDetail.setResolutionDueDate': 'Setează data scadentă de rezolvare',
  'ticketDetail.pickDateTime': 'Alege data și ora',
  'ticketDetail.resolutionDueLabel': 'Data scadentă de rezolvare',
  'ticketDetail.saveSla': 'Salvează SLA',
  'ticketDetail.savingSla': 'Se salvează…',
  'ticketDetail.noSlaPolicy': 'Nicio politică SLA nu este aplicată acestui tichet.',
  'ticketDetail.firstResponse': 'Primul răspuns',
  'ticketDetail.resolution': 'Rezolvare',
  'ticketDetail.done': 'Finalizat',
  'ticketDetail.pausedSince': 'Întrerupt de la {date}',
  'ticketDetail.escalation': 'Escaladare',
  'ticketDetail.escalatedLevel2': 'Escaladat (Nivel 2)',
  'ticketDetail.escalated': 'Escaladat',
  'ticketDetail.dueDateOverridden': 'Data scadentă a fost suprascrisă manual de un administrator.',
  'ticketDetail.dates': 'Date',
  'ticketDetail.created': 'Creat',
  'ticketDetail.updated': 'Actualizat',
  'ticketDetail.resolved': 'Rezolvat',
  'ticketDetail.closed': 'Închis',
  'ticketDetail.loadErrorTitle': 'Acest tichet nu a putut fi încărcat',
  'ticketDetail.notFound': 'Tichetul nu a fost găsit',
  'ticketDetail.confirmMergeTitle': 'Fuzionați tichetul nr. {source} cu nr. {target}?',
  'ticketDetail.confirmMergeDescription': 'Tichetul curent va fi închis. Această acțiune nu poate fi anulată.',
  'ticketDetail.confirmMergeLabel': 'Fuzionează tichetul',
  'ticketDetail.updateSuccess': 'Tichet actualizat',
  'ticketDetail.updateError': 'Tichetul nu a putut fi actualizat',
  'ticketDetail.pickDateTitle': 'Alegeți o dată',
  'ticketDetail.pickDateDescription': 'Alegeți o dată scadentă de rezolvare.',
  'ticketDetail.slaUpdateSuccess': 'SLA actualizat',
  'ticketDetail.slaUpdateError': 'SLA nu a putut fi actualizat',
  'ticketDetail.searchError': 'Tichetele nu au putut fi căutate',
  'ticketDetail.parentUpdateError': 'Tichetul părinte nu a putut fi actualizat',
  'ticketDetail.mergeSuccess': 'Fuzionat cu nr. {number}',
  'ticketDetail.mergeError': 'Tichetul nu a putut fi fuzionat',
  'ticketDetail.splitSuccess': 'Divizarea tichetului a fost creată',
  'ticketDetail.splitError': 'Tichetul nu a putut fi divizat',
  'ticketDetail.downloadError': 'Fișierul atașat nu a putut fi descărcat',
  'ticketDetail.followSuccess': 'Urmărește acum tichetul',
  'ticketDetail.unfollowSuccess': 'A oprit urmărirea tichetului',
  'ticketDetail.watcherError': 'Starea de urmărire nu a putut fi actualizată',
  'ticketDetail.fieldsLoadError': 'Câmpurile tichetului nu au putut fi încărcate',
  'ticketDetail.overdueBy': 'Întârziat cu {label}',
  'ticketDetail.dueLeft': '{label} rămas',
  'ticketDetail.presetToday': 'Astăzi',
  'ticketDetail.presetTomorrow': 'Mâine',
  'ticketDetail.presetThisWeek': 'Săptămâna aceasta',
  'ticketDetail.presetNextWeek': 'Săptămâna viitoare',
  'ticketDetail.presetThisMonth': 'Luna aceasta',
  'ticketDetail.eventTicketCreated': 'Tichet creat',
  'ticketDetail.eventStatusUpdated': 'Stare actualizată',
  'ticketDetail.eventAgentUpdated': 'Agent actualizat',
  'ticketDetail.eventSlaUpdated': 'SLA actualizat',
  'ticketDetail.eventTicketMerged': 'Tichet fuzionat',
  'ticketDetail.eventMergeReceived': 'Fuzionare primită',
  'ticketDetail.eventTicketSplit': 'Tichet divizat',
  'ticketDetail.eventUpdated': 'Actualizat',
  'ticketDetail.eventSplitContentCopied': 'Conținut divizat copiat',
  'ticketDetail.eventReplySent': 'Răspuns trimis',
  'ticketDetail.eventNoteAdded': 'Notă adăugată',
  'ticketDetail.eventCustomerReplied': 'Clientul a răspuns',
  'ticketDetail.eventTicketDeleted': 'Tichet șters',
  'preferences.createdEvent': 'Tichet creat',
  'preferences.pendingInputEvent': 'Un tichet așteaptă răspunsul dvs.',
  'preferences.resolvedEvent': 'Un tichet este rezolvat',
  'agents.assignGroups': 'Atribuie grupuri',
  'agents.assignGroupsHelp': 'Apartenența la grupuri controlează ce tichete poate vedea acest agent.',
  'agents.selectGroups': 'Selectează grupuri',
  'agents.ticketVisibility': 'Vizibilitatea tichetelor',
  'agents.ticketVisibilityHelp': 'Alege o limită mai restrânsă pentru agent sau moștenește valoarea implicită a rolului. Permisiunile rolului controlează în continuare ce poate face agentul.',
  'agents.scopeRoleDefault': 'Folosește valoarea implicită a rolului',
  'agents.scopeRoleDefaultHelp': 'Moștenește vizibilitatea implicită configurată pentru acest rol.',
  'agents.scopeAll': 'Toate tichetele',
  'agents.scopeAllHelp': 'Vezi toate tichetele care nu au fost șterse din acest cont.',
  'agents.scopeGroup': 'Tichete dintr-un grup',
  'agents.scopeGroupHelp': 'Vezi tichetele atribuite grupurilor din care face parte agentul.',
  'agents.scopeAssigned': 'Tichete atribuite',
  'agents.scopeAssignedHelp': 'Vezi tichetele atribuite direct acestui agent.',
  'agents.scopeCollaboratorHelp': 'Colaboratorii rămân limitați la tichetele din grupurile lor L1.',
  'nav.jira': 'Integrare Jira',
  'notifications.groupAssigned': 'Atribuire la grup',
  'notifications.groupMemberAdded': 'Adăugat într-un grup',
  'preferences.groupAssignedEvent': 'Un tichet este atribuit unuia dintre grupurile tale',
  'preferences.groupMemberAddedEvent': 'Ești adăugat într-un grup de asistență',
  'ui.select': 'Selectează…',
  'ui.any': 'Oricare',
  'ui.typeToSearch': 'Tastează pentru a căuta…',
  'ui.noResults': 'Nu s-au găsit rezultate',
  'ui.clearSelection': 'Șterge selecția',
  'ui.removeItem': 'Elimină {label}',
  'ui.pressEnterToUse': 'Apasă Enter pentru a folosi această valoare',
  'ui.removeFilter': 'Elimină filtrul {field}: {value}',
  'ui.removeTag': 'Elimină eticheta {label}',
  'ui.retry': 'Reîncearcă',
  'ui.errorTitle': 'Conținutul nu a putut fi încărcat',
  'ui.errorMessage': 'Verifică conexiunea și încearcă din nou.',
  'ui.reference': 'Referință: {id}',
  'ui.thisArea': 'această zonă',
  'ui.noAccess': 'Nu ai acces la {area}',
  'ui.noAccessHint': 'Cere unui administrator să acorde permisiunea necesară.',
  'ui.actionFailed': 'Acțiunea nu a putut fi finalizată. Încearcă din nou.',
  'ui.slaPaused': 'SLA suspendat',
  'ui.filteredEmptyTitle': 'Niciun tichet nu corespunde acestor filtre',
  'ui.filteredEmptyDescription': 'Încearcă să elimini un filtru sau să extinzi intervalul de date.',
  'ui.clearFilters': 'Șterge filtrele',
  'pagination.noResults': 'Niciun rezultat',
  'pagination.showing': 'Se afișează {first}–{last} din {total}',
  'pagination.resultsPerPage': 'Rezultate pe pagină',
  'pagination.perPage': '{count} pe pagină',
  'pagination.previous': 'Anterior',
  'pagination.next': 'Următor',
  'pagination.previousAria': 'Pagina anterioară',
  'pagination.nextAria': 'Pagina următoare',
  'pagination.pageOf': 'Pagina {page} din {total}',
  'status.open': 'Deschis',
  'status.to_be_prioritised': 'De prioritizat',
  'status.work_in_progress': 'În lucru',
  'status.assigned_to_ai_agent': 'Atribuit agentului AI',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'În așteptare',
  'status.awaiting_user_reply': 'Se așteaptă răspunsul utilizatorului',
  'status.awaiting_resolution_confirmation': 'Se așteaptă confirmarea rezolvării',
  'status.on_hold': 'Suspendat',
  'status.pending_production_release': 'Lansare în producție în așteptare',
  'status.product_cr': 'CR produs',
  'status.reopened': 'Redeschis',
  'status.issue_fixed': 'Problemă remediată',
  'status.resolved': 'Rezolvat',
  'status.closed': 'Închis',
  'status.unknown': 'Necunoscut',
  'priority.low': 'Scăzută',
  'priority.medium': 'Medie',
  'priority.high': 'Ridicată',
  'priority.urgent': 'Urgentă',
  'source.email': 'Email',
  'source.portal': 'Portal',
  'source.phone': 'Telefon',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Chat web',
  'source.web_form': 'Formular web',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget de feedback',
  'source.outbound_email': 'Email trimis',
  'source.ecommerce': 'Comerț electronic',
  'source.bot': 'Bot',
  'source.instagram_message': 'Mesaj Instagram',
  'source.instagram_comment': 'Comentariu Instagram',
  'source.facebook_message': 'Mesaj Facebook',
  'source.facebook_comment': 'Comentariu Facebook',
  'source.mobile_chat_sdk': 'SDK chat mobil',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Vizualizări salvate',
  'savedViews.saveCurrent': 'Salvează filtrele curente ca vizualizare',
  'savedViews.namePlaceholder': 'Numele vizualizării...',
  'savedViews.nameAria': 'Numele vizualizării',
  'savedViews.empty': 'Nu există vizualizări salvate. Aplică filtre și salvează-le aici.',
  'savedViews.listAria': 'Lista vizualizărilor salvate',
  'savedViews.rename': 'Redenumește vizualizarea „{name}”',
  'savedViews.delete': 'Șterge vizualizarea „{name}”',
  'export.title': 'Exportă tichete',
  'export.loadError': 'Lista câmpurilor de export nu a putut fi încărcată.',
  'export.failed': 'Exportul a eșuat. Încearcă din nou.',
  'export.pdfFailed': 'Exportul PDF a eșuat. Încearcă din nou.',
  'export.fieldsSelectedOne': '{count} câmp selectat',
  'export.fieldsSelectedMany': '{count} câmpuri selectate',
  'export.fieldsTotalOne': '{count} câmp în total',
  'export.fieldsTotalMany': '{count} câmpuri în total',
  'export.selectAllFields': 'Selectează toate câmpurile',
  'export.exportingOne': 'Se exportă 1 tichet selectat.',
  'export.exportingMany': 'Se exportă {count} tichete selectate.',
  'export.pdfZip': 'Descarcă ca PDF (.zip, {count} fișiere)',
  'export.pdf': 'Descarcă ca PDF',
  'export.pdfZipHint': 'Generează un PDF pentru fiecare tichet și le comprimă într-o singură descărcare ZIP.',
  'export.pdfHint': 'Generează un singur PDF cu proprietățile tichetului și conversația publică.',
  'export.formatLabel': 'Exportă ca (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Se încarcă lista de câmpuri…',
  'export.ticketFields': 'Câmpuri tichet',
  'export.contactFields': 'Câmpuri contact',
  'export.companyFields': 'Câmpuri companie',
  'export.exporting': 'Se exportă…',
  'newTicket.title': 'Creează tichet',
  'newTicket.description': 'Alege un formular salvat și completează câmpurile.',
  'newTicket.form': 'Formular tichet',
  'newTicket.noForms': 'Nu există formulare de tichet disponibile. Configurează un formular înainte de a crea un tichet.',
  'newTicket.loadFormsError': 'Formularele de tichet nu au putut fi încărcate',
  'newTicket.loadFormError': 'Formularul de tichet selectat nu a putut fi încărcat',
  'newTicket.addCc': 'Adaugă CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Elimină {name}',
  'newTicket.requesterRequired': 'Solicitantul este obligatoriu',
  'newTicket.subjectRequired': 'Subiectul este obligatoriu',
  'newTicket.createFailed': 'Crearea tichetului a eșuat',
  'newTicket.noFormTitle': 'Nu există niciun formular de tichet disponibil',
  'newTicket.noFormDescription': 'Creează un formular de tichet în Setări, apoi revino pentru a deschide un tichet.',
  'newTicket.noFieldsTitle': 'Acest formular nu are încă câmpuri',
  'newTicket.noFieldsDescription': 'Adaugă câmpuri în formular din Setări, apoi reîncarcă pagina.',
  'newTicket.creating': 'Se creează...',
  'newTicket.submit': 'Creează tichet',
  'fields.required': '{label} este obligatoriu',
  'fields.selectParentFirst': 'Selectează mai întâi o valoare părinte...',
  'fields.selectPlaceholder': 'Selectează {label}...',
  'fields.enterPlaceholder': 'Introdu {label}...',
  'fields.optionsLoadError': 'Opțiunile pentru {label} nu au putut fi încărcate',
  'fields.label.requester': 'Solicitant',
  'fields.label.subject': 'Subiect',
  'fields.label.description': 'Descriere',
  'fields.label.status': 'Stare',
  'fields.label.priority': 'Prioritate',
  'fields.label.source': 'Sursă',
  'fields.label.ticket_type': 'Tip',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Grup',
  'fields.label.internal_agent': 'Agent intern',
  'fields.label.internal_group': 'Grup intern',
  'fields.label.company': 'Companie',
  'editor.defaultPlaceholder': 'Scrie aici...',
  'editor.ariaLabel': 'Editor de text îmbogățit',
  'editor.toolbarAria': 'Formatare text',
  'editor.bold': 'Aldin (Ctrl+B)',
  'editor.italic': 'Cursiv (Ctrl+I)',
  'editor.underline': 'Subliniat (Ctrl+U)',
  'editor.strikethrough': 'Tăiat',
  'editor.heading1': 'Titlu 1',
  'editor.heading2': 'Titlu 2',
  'editor.textColor': 'Culoare text',
  'editor.highlight': 'Evidențiere',
  'editor.bulletList': 'Listă cu buline',
  'editor.numberedList': 'Listă numerotată',
  'editor.blockquote': 'Citat',
  'editor.codeBlock': 'Bloc de cod',
  'editor.insertLink': 'Inserează link',
  'editor.insertImage': 'Inserează imagine',
  'editor.insertTable': 'Inserează tabel',
  'editor.mention': 'Menționează pe cineva',
  'editor.undo': 'Anulează (Ctrl+Z)',
  'editor.redo': 'Refă (Ctrl+Shift+Z)',
  'editor.attach': 'Atașează fișier',
  'editor.noAgents': 'Nu s-au găsit agenți',
  'editor.mentionSuggestions': 'Sugestii de mențiune',
  'editor.dialogLinkTitle': 'Inserează link',
  'editor.dialogImageTitle': 'Inserează imagine',
  'editor.linkHint': 'Introdu un URL HTTP(S), mailto, ancoră sau relativ.',
  'editor.imageHint': 'Introdu un URL de imagine HTTP(S) sau relativ.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Introdu un URL HTTP(S), mailto, ancoră sau relativ valid.',
  'editor.invalidImage': 'Introdu un URL de imagine HTTP(S) sau relativ valid.',
  'editor.selectTextForLink': 'Selectează textul înainte de a adăuga un link.',
  'editor.imageInsertFailed': 'Imaginea nu a putut fi inserată aici.',
  'editor.insertLinkAction': 'Inserează link',
  'editor.insertImageAction': 'Inserează imagine',
  'search.dialogAria': 'Căutare globală',
  'search.placeholder': 'Caută tichete, contacte...',
  'search.aria': 'Caută',
  'search.close': 'Închide căutarea',
  'search.noMatches': 'Niciun rezultat pentru „{query}”',
  'search.noMatchesHint': 'Încearcă un număr de tichet, un email de contact sau un nume de companie.',
  'search.hintBefore': 'Tastează cel puțin 2 caractere pentru a căuta. Apasă',
  'search.hintAfter': 'pentru a închide.',

  'td.system': 'Sistem',
  'td.actionCreatedTicket': 'a creat tichetul',
  'td.actionUpdatedFields': 'a actualizat {fields}',
  'td.fieldStatus': 'starea',
  'td.fieldPriority': 'prioritatea',
  'td.fieldSource': 'sursa',
  'td.fieldType': 'tipul',
  'td.fieldGroup': 'grupul',
  'td.fieldAgent': 'agentul',
  'td.fieldCompany': 'compania',
  'td.fieldContact': 'contactul',
  'td.fieldSubject': 'subiectul',
  'td.fieldDescription': 'descrierea',
  'td.fieldProduct': 'produsul',
  'td.fieldResolutionDue': 'data scadentă a rezolvării',
  'td.fieldFirstResponseDue': 'data scadentă a primului răspuns',
  'td.fieldTags': 'etichetele',
  'td.fieldParentTicket': 'tichetul părinte',
  'td.eventCreated': '{actor} a creat un tichet nou',
  'td.eventCreatedLinked': '{actor} a creat un tichet nou și l-a asociat unui tichet părinte',
  'td.eventSplit': '{actor} a împărțit acest tichet și a creat tichetul copil{ref}',
  'td.eventMergeReceived': '{actor} a îmbinat un alt tichet în acest tichet{ref}',
  'td.eventMerged': '{actor} a îmbinat acest tichet într-un alt tichet{ref}',
  'td.eventSplitCopied': '{actor} a copiat {conversations} și {attachments}',
  'td.conversationsOne': '{count} conversație',
  'td.conversationsMany': '{count} conversații',
  'td.attachmentsOne': '{count} atașament',
  'td.attachmentsMany': '{count} atașamente',
  'td.eventUpdatedFields': '{actor} a actualizat {fields}',
  'td.invalidSlaState': 'Serverul a returnat o stare SLA nevalidă.',
  'td.slaRefreshError': 'Nu s-au putut reîmprospăta cronometrele SLA.',
  'td.descriptionUpdated': 'Descriere actualizată',
  'td.descriptionUpdateError': 'Nu s-a putut actualiza descrierea',
  'td.descriptionUpdateFailed': 'Actualizarea descrierii a eșuat',
  'td.entryUpdated': 'Intrare actualizată',
  'td.entryUpdateError': 'Nu s-a putut actualiza intrarea',
  'td.updateFailed': 'Actualizarea a eșuat',
  'td.loadOlderError': 'Nu s-au putut încărca conversațiile mai vechi',
  'td.loadFailed': 'Încărcarea a eșuat',
  'td.slaUpdateFailed': 'Actualizarea SLA a eșuat',
  'td.reasonTooLong': 'Motivul trebuie să aibă cel mult 500 de caractere.',
  'td.invalidDateTime': 'Alegeți o dată și o oră valide.',
  'td.slaDeadlineUpdated': 'Termen SLA actualizat',
  'td.slaConflict': 'Tichetul s-a modificat în timp ce editați datele SLA. Reîncărcați înainte de a încerca din nou.',
  'td.slaClearFailed': 'Ștergerea SLA a eșuat',
  'td.slaTargetCleared': 'Țintă SLA ștearsă',
  'td.slaClearError': 'Nu s-a putut șterge ținta SLA',
  'td.noDescription': 'Nu a fost adăugată încă nicio descriere.',
  'td.editDescriptionAria': 'Editează descrierea tichetului',
  'td.download': 'Descarcă',
  'td.downloadFile': 'Descarcă {fileName}',
  'td.loadOlder': '↓ +{count} conversație',
  'td.loadOlderMany': '↓ +{count} conversații',
  'td.edited': '(editat)',
  'td.privateThread': 'Fir privat',
  'td.propertiesAria': 'Proprietățile tichetului',
  'td.expandProperties': 'Extinde proprietățile',
  'td.collapseProperties': 'Restrânge proprietățile',
  'td.metric': 'Indicator',
  'td.firstResponseOption': 'Primul răspuns',
  'td.resolutionOption': 'Rezolvare',
  'td.overrideHint': 'Setați o suprascriere de termen impusă de server. Motivul este păstrat în istoricul SLA.',
  'td.deadline': 'Termen limită',
  'td.reasonOptional': 'Motiv (opțional)',
  'td.reasonPlaceholder': 'Excepție aprobată sau context operațional',
  'td.clearResolutionOverride': 'Șterge suprascrierea rezolvării',
  'td.clearEscalationTarget': 'Șterge ținta de escaladare',
  'td.toolsAria': 'Instrumentele tichetului și contactul',
  'td.ticketContext': 'Contextul tichetului',
  'td.knowledgeBase': 'Bază de cunoștințe',
  'td.shortcutsAria': 'Comenzi rapide pentru contextul tichetului',
  'td.showContext': 'Afișează contextul tichetului',
  'td.hideContext': 'Ascunde contextul tichetului',
  'td.openRow': 'Deschide {label}',
  'td.editTicket': 'Editează tichetul',
  'td.searchContactPlaceholder': 'Caută contact…',
  'td.describePlaceholder': 'Descrieți problema…',
  'td.noAttachments': 'Niciun atașament',

  'tp.api.csrfUnavailable': 'Nu s-a putut stabili protecția CSRF',
  'tp.api.noMfaChallenge': 'Nicio provocare MFA activă',
  'tp.api.noMfaSetup': 'Nicio provocare de configurare MFA activă',
  'tp.api.noNewPasswordChallenge': 'Nicio provocare de parolă nouă activă',
  'tp.articles.isLinkedAria': '{title} este asociat ca soluție',
  'tp.articles.linkAria': 'Asociază {title} ca soluție',
  'tp.articles.linkAsSolution': 'Asociază ca soluție',
  'tp.articles.linkedAsSolution': 'Asociat ca soluție',
  'tp.articles.none': 'Niciun articol sugerat pentru acest tichet.',
  'tp.articles.title': 'Articole sugerate',
  'tp.articles.views': '{count} vizualizări',
  'tp.attachment.loadingPreview': 'Se încarcă previzualizarea…',
  'tp.attachment.previewUnavailable': 'Previzualizare indisponibilă',
  'tp.charts.noData': 'Nu există date de grafic pentru această perioadă.',
  'tp.charts.noRecords': 'Nu există înregistrări în această perioadă.',
  'tp.charts.period': 'Perioadă',
  'tp.charts.showingTop': 'Se afișează primele {shown} din {total} segmente.',
  'tp.common.cancel': 'Anulează',
  'tp.common.clear': 'Șterge',
  'tp.common.loading': 'Se încarcă…',
  'tp.common.send': 'Trimite',
  'tp.common.sending': 'Se trimite…',
  'tp.common.system': 'Sistem',
  'tp.convActions.edit': 'Editează',
  'tp.convActions.thread': 'Începe un fir',
  'tp.dashboard.new': 'Nou',
  'tp.dashboard.select': 'Selectează tabloul de bord',
  'tp.forward.failed': 'Redirecționarea a eșuat',
  'tp.forward.forwarded': 'Tichet redirecționat',
  'tp.forward.forwarding': 'Se redirecționează…',
  'tp.forward.forwardingMany': 'Se redirecționează {count} conversații:',
  'tp.forward.forwardingOne': 'Se redirecționează 1 conversație:',
  'tp.forward.message': 'Mesaj',
  'tp.forward.messagePlaceholder': 'Adăugați un mesaj (opțional)…',
  'tp.forward.noContacts': 'Nu s-au găsit contacte — introduceți o adresă de e-mail completă',
  'tp.forward.recipientEmail': 'E-mail destinatar',
  'tp.forward.recipientInvalid': 'Introduceți o adresă de e-mail validă a destinatarului',
  'tp.forward.recipientRequired': 'E-mailul destinatarului este obligatoriu',
  'tp.forward.searchContact': 'Caută un contact sau introdu un e-mail…',
  'tp.forward.title': 'Redirecționează',
  'tp.forward.to': 'Către',
  'tp.forward.useThisEmail': 'Apăsați Enter sau faceți clic pe Redirecționează pentru a folosi acest e-mail',
  'tp.jira.addOptional': 'Adaugă câmpuri opționale',
  'tp.jira.createAndLink': 'Creează și asociază problema',
  'tp.jira.createIssue': 'Creează problema',
  'tp.jira.createTitle': 'Creează o problemă Jira',
  'tp.jira.describePlaceholder': 'Descrieți problema…',
  'tp.jira.description': 'Descriere',
  'tp.jira.development': 'Dezvoltare',
  'tp.jira.enterDevelopment': 'Introduceți dezvoltarea',
  'tp.jira.hideOptional': 'Ascunde câmpurile opționale',
  'tp.jira.issueId': 'ID problemă',
  'tp.jira.issueSummary': 'Rezumatul problemei',
  'tp.jira.issueType': 'Tip problemă *',
  'tp.jira.lastSync': 'Ultima sincronizare: {error}',
  'tp.jira.linkIssue': 'Asociază problema',
  'tp.jira.linkTitle': 'Asociază o problemă Jira',
  'tp.jira.linkedIssues': 'Probleme asociate',
  'tp.jira.linkedIssuesHint': 'Folosiți chei de probleme Jira separate prin virgule.',
  'tp.jira.linkedIssuesPlaceholder': 'ex. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Se încarcă câmpurile Jira…',
  'tp.jira.loadingIssueTypes': 'Se încarcă tipurile de probleme…',
  'tp.jira.loadingProjects': 'Se încarcă proiectele Jira…',
  'tp.jira.loadingUsers': 'Se încarcă utilizatorii Jira…',
  'tp.jira.noLinks': 'Nicio problemă Jira nu este asociată încă acestui tichet.',
  'tp.jira.noneFound': 'Nu s-a găsit nicio problemă Jira.',
  'tp.jira.notAvailableProject': 'Indisponibil pentru acest proiect',
  'tp.jira.projects': 'Proiecte *',
  'tp.jira.refresh': 'Reîmprospătează',
  'tp.jira.refreshFields': 'Reîmprospătează câmpurile Jira',
  'tp.jira.reporter': 'Raportor',
  'tp.jira.requestFailed': 'Solicitarea Jira a eșuat. Încercați din nou.',
  'tp.jira.searchBy': 'Caută după:',
  'tp.jira.searchIssue': 'Caută problemă',
  'tp.jira.searchIssuePlaceholder': 'Caută problemă…',
  'tp.jira.searchUsers': 'Caută utilizatori Jira',
  'tp.jira.searching': 'Se caută în Jira…',
  'tp.jira.selectIssueType': 'Selectați un tip de problemă',
  'tp.jira.selectProject': 'Selectați un proiect',
  'tp.jira.summary': 'Rezumat *',
  'tp.jira.syncOff': 'Sincronizare oprită',
  'tp.jira.syncOn': 'Sincronizare activă',
  'tp.jira.syncStatus': 'Sincronizează starea tichetului în Jira',
  'tp.jira.unassigned': 'Neatribuit',
  'tp.jira.unlink': 'Dezasociază',
  'tp.jira.unlinkConfirm': 'Dezasociază problema',
  'tp.jira.unlinkDescription': 'Aceasta elimină legătura din tichet, dar nu șterge problema Jira.',
  'tp.jira.unlinkTitle': 'Dezasociați {key}?',
  'tp.jira.untitled': 'Problemă Jira fără titlu',
  'tp.layout.loadingPage': 'Se încarcă pagina…',
  'tp.notFound.goToDashboard': 'Mergi la tabloul de bord',
  'tp.notFound.title': 'Pagina nu a fost găsită',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Client',
  'tp.reply.addNote': 'Adaugă notă',
  'tp.reply.attachmentNotAdded': 'Atașamentul nu a fost adăugat',
  'tp.reply.clickToExpand': 'Faceți clic pentru a extinde',
  'tp.reply.collapsedNote': 'Adăugați o notă internă…',
  'tp.reply.collapsedReply': 'Scrieți un răspuns sau o notă…',
  'tp.reply.conversationType': 'Tip conversație',
  'tp.reply.failedToSend': 'Trimiterea a eșuat',
  'tp.reply.markNoteAs': 'Marchează nota ca',
  'tp.reply.notVisibleToContact': 'Nu este vizibil pentru contact',
  'tp.reply.notVisibleToContacts': 'Nu este vizibil pentru contacte',
  'tp.reply.noteAdded': 'Notă adăugată',
  'tp.reply.notifyTo': 'Notifică',
  'tp.reply.placeholderPrivateNote': 'Adăugați o notă privată...',
  'tp.reply.placeholderPublicNote': 'Adăugați o notă publică vizibilă solicitantului...',
  'tp.reply.placeholderReply': 'Scrieți răspunsul...',
  'tp.reply.private': 'Privat',
  'tp.reply.public': 'Public',
  'tp.reply.removeFile': 'Elimină {name}',
  'tp.reply.replySent': 'Răspuns trimis',
  'tp.reply.searchAgentsToNotify': 'Caută agenți de notificat…',
  'tp.reply.sendReply': 'Trimite răspunsul',
  'tp.reply.sending': 'Se trimite...',
  'tp.reply.tabNote': 'Notă',
  'tp.reply.tabReply': 'Răspuns',
  'tp.reply.uploadAttachment': 'Încarcă atașament',
  'tp.reply.visibleToContact': 'Vizibil pentru contact',
  'tp.reply.visibleToContacts': 'Vizibil pentru contacte',
  'tp.sla.breached': 'Depășit',
  'tp.sla.cleared': 'Șters',
  'tp.sla.configErrorNoDeadline': 'Eroare de configurare SLA. Nu se deduce niciun termen limită.',
  'tp.sla.configurationError': 'Eroare de configurare',
  'tp.sla.couldNotLoad': 'Nu s-au putut încărca cronometrele SLA',
  'tp.sla.done': 'Finalizat',
  'tp.sla.dueIn': 'Scadent în {duration}',
  'tp.sla.dueLine': 'Scadent: {date}',
  'tp.sla.dueNow': 'Scadent acum',
  'tp.sla.escalated': 'Escaladat',
  'tp.sla.firstResponse': 'Primul răspuns',
  'tp.sla.invalidDeadline': 'Termen limită nevalid',
  'tp.sla.mayBeStale': 'Cronometrele SLA pot fi depășite',
  'tp.sla.noActiveCycle': 'Niciun ciclu SLA activ.',
  'tp.sla.noDeadline': 'Fără termen limită',
  'tp.sla.noMetrics': 'Nu sunt disponibili indicatori SLA pentru acest ciclu.',
  'tp.sla.noPolicy': 'Nicio politică SLA aplicată acestui tichet.',
  'tp.sla.notConfigured': 'Neconfigurat',
  'tp.sla.notStarted': 'Neînceput',
  'tp.sla.overdueBy': 'Întârziat cu {duration}',
  'tp.sla.overridden': 'Suprascris',
  'tp.sla.overrideReason': 'Motivul suprascrierii: {reason}',
  'tp.sla.paused': 'În pauză',
  'tp.sla.refreshing': 'Se reîmprospătează cronometrele SLA autoritative…',
  'tp.sla.resolution': 'Rezolvare',
  'tp.sla.stopsSla': 'Oprește SLA',
  'tp.thread.empty': 'Nu s-a trimis încă nimic. Primul dvs. mesaj va începe acest fir privat.',
  'tp.thread.messageFailed': 'Mesajul a eșuat',
  'tp.thread.privateThread': 'Fir privat',
  'tp.thread.replyPlaceholder': 'Răspundeți în fir…',
  'tp.thread.someone': 'Cineva',
  'tp.thread.startPrivateThread': 'Începe un fir privat',
  'tp.thread.startedBy': '{name} a început acest fir',
  'tp.thread.unableToSend': 'Nu s-a putut trimite mesajul',
  'tp.ui.breadcrumb': 'Cale de navigare',
  'tp.ui.closePanel': 'Închide panoul',
  'tp.ui.dismiss': 'Închide {title}',

  'dir.loadError': 'Nu s-au putut încărca datele. Încercați din nou.',
  'dir.contacts.description': 'Contactele clienților și istoricul lor de asistență.',
  'dir.contacts.searchAria': 'Caută contacte',
  'dir.contacts.count': '{count} contacte',
  'dir.contacts.noMatch': 'Niciun contact nu corespunde acestei căutări',
  'dir.contacts.none': 'Niciun contact încă',
  'dir.contacts.noneDescription': 'Contactele apar aici după ce clienții încep să trimită tichete.',
  'dir.company': 'Companie',
  'dir.unnamedContact': 'Contact fără nume',
  'dir.contact': 'Contact',
  'dir.contactNotFound': 'Contactul nu a fost găsit.',
  'dir.confirmDeleteContactTitle': 'Ștergeți „{name}”?',
  'dir.thisContact': 'acest contact',
  'dir.confirmDeleteContactDescription': 'Contactele cu tichete vor fi dezactivate în loc să fie șterse definitiv.',
  'dir.deleteContact': 'Șterge contactul',
  'dir.editProfile': 'Editează profilul',
  'dir.profile': 'Profil',
  'dir.firstName': 'Prenume',
  'dir.lastName': 'Nume',
  'dir.phone': 'Telefon',
  'dir.timezone': 'Fus orar',
  'dir.emailLabel': 'E-mail:',
  'dir.phoneLabel': 'Telefon:',
  'dir.companyLabel': 'Companie:',
  'dir.timezoneLabel': 'Fus orar:',
  'dir.recentTickets': 'Tichete recente',
  'dir.noTicketsYet': 'Niciun tichet încă',
  'dir.contactTicketsDescription': 'Tichetele deschise de acest contact vor fi listate aici.',
  'dir.ticket': 'Tichet',
  'dir.subject': 'Subiect',
  'dir.status': 'Stare',
  'dir.created': 'Creat',
  'dir.companies.description': 'Organizații asociate contactelor clienților și tichetelor.',
  'dir.companies.add': 'Adaugă companie',
  'dir.companies.domain': 'Domeniu',
  'dir.companies.create': 'Creează compania',
  'dir.companies.searchAria': 'Caută companii',
  'dir.companies.searchPlaceholder': 'Caută companii sau domenii',
  'dir.companies.noMatch': 'Nicio companie nu corespunde acestei căutări',
  'dir.companies.addFirst': 'Adăugați prima companie',
  'dir.companies.tryDifferent': 'Încercați un alt nume de companie sau alt domeniu.',
  'dir.companies.useForm': 'Folosiți formularul de lângă această listă pentru a crea o companie.',
  'dir.companies.contacts': 'Contacte',
  'dir.companies.tickets': 'Tichete',
  'dir.companies.notFound': 'Compania nu a fost găsită.',
  'dir.companies.confirmDeleteTitle': 'Ștergeți „{name}”?',
  'dir.companies.thisCompany': 'această companie',
  'dir.companies.confirmDeleteDescription': 'Compania nu trebuie să aibă contacte sau tichete pentru a putea fi ștearsă.',
  'dir.companies.delete': 'Șterge compania',
  'dir.companies.noDomain': 'Niciun domeniu configurat',
  'dir.companies.contactsCount': 'Contacte ({count})',
  'dir.companies.ticketsCount': 'Tichete ({count})',
  'dir.companies.noContactsDescription': 'Adăugați un contact și asociați-l acestei companii pentru a-l vedea aici.',
  'dir.companies.noTicketsDescription': 'Tichetele deschise de contactele acestei companii vor fi listate aici.',
  'dir.trendsCreatedHour': 'Data creării - Ora din zi',
  'dir.reports.loadError': 'Nu s-a putut încărca acest raport. Încercați din nou.',
  'dir.reports.volume': 'Volum de tichete',
  'dir.reports.sla': 'Conformitate SLA',
  'dir.reports.agents': 'Performanța agenților',
  'dir.reports.csat': 'Satisfacția clienților',
  'dir.reports.rca': 'Analiza cauzei principale',
  'dir.reports.descVolume': 'Vedeți de unde vin tichetele și cum parcurg ciclul de viață.',
  'dir.reports.descSla': 'Urmăriți țintele de răspuns și rezolvare în întreaga activitate de asistență accesibilă.',
  'dir.reports.descAgents': 'Comparați volumul de lucru, rezultatele, răspunsurile și timpii medii de gestionare pe agent.',
  'dir.reports.descCsat': 'Citiți sentimentul clienților fără a confunda volumul de răspunsuri cu rata de satisfacție.',
  'dir.reports.descRca': 'Găsiți cauzele principale standardizate din spatele cererii de tichete.',
  'dir.reports.noPayload': 'Nu a fost returnat niciun conținut de raport pentru această perioadă.',
  'dir.reports.refresh': 'Reîmprospătează',
  'dir.reports.report': 'Raport',
  'dir.reports.from': 'De la',
  'dir.reports.to': 'Până la',
  'dir.reports.maxRange': 'Interval maxim: 90 de zile · sfera urmează permisiunile contului dvs.',
  'dir.reports.unclassified': 'Neclasificat',
  'dir.reports.ticketsInPeriod': 'Tichete în perioadă',
  'dir.reports.ticketsInPeriodDetail': 'Tichete accesibile returnate de raport',
  'dir.reports.created': 'Create',
  'dir.reports.createdDetail': 'Pe axa de date selectată',
  'dir.reports.resolved': 'Rezolvate',
  'dir.reports.resolvedDetail': '{percent}% din volumul creat',
  'dir.reports.noCreated': 'Niciun tichet creat',
  'dir.reports.reopened': 'Redeschise',
  'dir.reports.reopenedDetail': 'Evenimente de ciclu de viață, nu tichete unice',
  'dir.reports.dailyPulse': 'Pulsul zilnic',
  'dir.reports.volumeByDate': 'Volum de tichete pe dată',
  'dir.reports.volumeByDateDescription': 'Rândurile rare din backend sunt extinse într-o axă de date completă, completată cu zerouri.',
  'dir.reports.createdTickets': 'Tichete create',
  'dir.reports.createdVolumeAria': 'Volumul de tichete create pe dată',
  'dir.reports.lifecycle': 'Ciclu de viață',
  'dir.reports.lifecycleTitle': 'Create, rezolvate, redeschise',
  'dir.reports.lifecycleDescription': 'O vedere cu trei linii a mișcării prin ciclul de viață al tichetelor.',
  'dir.reports.lifecycleAria': 'Evenimentele ciclului de viață al tichetelor pe dată',
  'dir.reports.dimensions': 'Dimensiuni',
  'dir.reports.whereConcentrated': 'Unde este concentrat volumul',
  'dir.reports.topEight': 'Se afișează primele opt segmente per panou',
  'dir.reports.status': 'Stare',
  'dir.reports.statusDescription': 'Starea curentă a tichetului',
  'dir.reports.priority': 'Prioritate',
  'dir.reports.priorityDescription': 'Distribuția priorităților tichetelor',
  'dir.reports.group': 'Grup',
  'dir.reports.groupDescription': 'Grupuri de rutare',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Responsabilitate atribuită',
  'dir.reports.product': 'Produs',
  'dir.reports.productDescription': 'Distribuția produselor',
  'dir.reports.country': 'Țară',
  'dir.reports.countryDescription': 'Din câmpurile standardizate de țară',
  'dir.reports.noRecords': 'Nu există înregistrări în această perioadă.',
  'dir.reports.slaSummary': '{rate} · {met} din {total} respectate',
  'dir.reports.noSlaSegments': 'Niciun segment SLA încă',
  'dir.reports.noSlaSegmentsDescription': 'Nu există înregistrări SLA aplicabile pentru această dimensiune în perioada selectată.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'Primul răspuns',
  'dir.reports.resolution': 'Rezolvare',
  'dir.reports.avgFirstResponse': 'Primul răspuns mediu',
  'dir.reports.avgResolution': 'Rezolvare medie',
  'dir.reports.fromTicketMetric': 'Din TicketMetric',
  'dir.reports.slaLens': 'Perspectivă SLA',
  'dir.reports.performanceBySegment': 'Performanța pe segmente',
  'dir.reports.slaRatesNote': 'Ratele folosesc doar înregistrările cu o țintă SLA aplicabilă. Duratele sunt timpul mediu scurs.',
  'dir.reports.slaDimensionAria': 'Dimensiunea defalcării SLA',
  'dir.reports.rosterSignal': 'Semnal de echipă',
  'dir.reports.agentPerformance': 'Performanța agenților',
  'dir.reports.agentPerformanceDescription': 'Sunt incluși toți agenții activi, inclusiv cei fără activitate.',
  'dir.reports.filterAgentsAria': 'Filtrează agenții',
  'dir.reports.filterAgentsPlaceholder': 'Filtrează după agent sau e-mail',
  'dir.reports.matchingAgents': '{count} agenți corespunzători',
  'dir.reports.activeAgents': '{count} agenți activi',
  'dir.reports.sortedBy': 'sortat după {key} {direction}',
  'dir.reports.asc': 'crescător',
  'dir.reports.desc': 'descrescător',
  'dir.reports.noAgentsMatch': 'Niciun agent nu corespunde acestui filtru',
  'dir.reports.assigned': 'Atribuite',
  'dir.reports.replies': 'Răspunsuri',
  'dir.reports.csatScore': 'Scor CSAT',
  'dir.reports.csatScoreDetail': 'Evaluări de 4 sau 5',
  'dir.reports.averageRating': 'Evaluare medie',
  'dir.reports.averageRatingDetail': 'Din sondajele evaluate',
  'dir.reports.ratedSurveys': 'Sondaje evaluate',
  'dir.reports.ratedSurveysDetail': 'În perioada selectată',
  'dir.reports.satisfied': 'Mulțumiți',
  'dir.reports.satisfiedDetail': 'Răspunsuri pozitive',
  'dir.reports.responseTrend': 'Tendința răspunsurilor',
  'dir.reports.surveyVolume': 'Volumul sondajelor pe dată',
  'dir.reports.surveyVolumeDescription': 'Backend-ul returnează numărul de răspunsuri pe dată; nu este un scor zilnic. Mai jos sunt eșantionate ultimele 100 de răspunsuri.',
  'dir.reports.surveyResponses': 'Răspunsuri la sondaj',
  'dir.reports.surveyVolumeAria': 'Volumul răspunsurilor la sondajul CSAT pe dată',
  'dir.reports.responsesByGroup': 'Răspunsuri pe grup',
  'dir.reports.responsesByGroupDescription': 'Numărul de răspunsuri la sondaj, nu rata de satisfacție a grupului',
  'dir.reports.responsesByAgent': 'Răspunsuri pe agent',
  'dir.reports.responsesByAgentDescription': 'Numărul de răspunsuri la sondaj, nu rata de satisfacție a agentului',
  'dir.reports.customerVoice': 'Vocea clientului',
  'dir.reports.latestSurveys': 'Ultimele răspunsuri la sondaj',
  'dir.reports.boundedSample': 'Eșantion limitat · {count} din maximum 100',
  'dir.reports.latestSurveysNote': 'Cele mai noi răspunsuri returnate de API-ul de raportare. Folosiți acest tabel pentru o privire rapidă, nu pentru un export complet.',
  'dir.reports.noSurveys': 'Niciun răspuns la sondaj',
  'dir.reports.noSurveysDescription': 'Răspunsurile CSAT vor apărea aici după ce clienții evaluează un tichet rezolvat.',
  'dir.reports.rating': 'Evaluare',
  'dir.reports.comment': 'Comentariu',
  'dir.reports.received': 'Primit',
  'dir.reports.ratingOutOf': '{rating} din 5',
  'dir.reports.noComment': 'Fără comentariu',
  'dir.reports.rcaEyebrow': 'Analiza cauzei principale',
  'dir.reports.rcaTitle': 'De ce sunt create tichete',
  'dir.reports.rcaDescription': 'Categoria și subcategoria sunt agregări independente din câmpurile personalizate standardizate ale tichetelor.',
  'dir.reports.rcaDimensionAria': 'Dimensiunea RCA',
  'dir.reports.category': 'Categorie',
  'dir.reports.subcategory': 'Subcategorie',
  'dir.reports.rcaEmpty': 'Nu au fost înregistrate valori ale cauzei principale pentru această perioadă.',
  'dir.kb.articleLoadError': 'Nu s-a putut încărca articolul.',
  'dir.kb.articleNotFound': 'Articolul nu a fost găsit.',
  'dir.kb.retry': 'Reîncearcă',
  'dir.kb.title': 'Bază de cunoștințe',
  'dir.kb.breadcrumb': 'Bază de cunoștințe',
  'dir.kb.description': '{articles} articole în {folders} foldere',
  'dir.kb.newArticle': 'Articol nou',
  'dir.kb.editArticle': 'Editează articolul',
  'dir.kb.sectionsAria': 'Secțiunile bazei de cunoștințe',
  'dir.kb.tabArticles': 'Articole',
  'dir.kb.tabStructure': 'Categorii și foldere',
  'dir.kb.folderFilterAria': 'Filtru de foldere',
  'dir.kb.allArticles': 'Toate articolele ({count})',
  'dir.kb.writeFirst': 'Scrieți primul articol',
  'dir.kb.writeFirstDescription': 'Folosiți Articol nou pentru a adăuga conținut în acest folder.',
  'dir.kb.byAuthor': 'de {name}',
  'dir.kb.views': '{count} vizualizări',
  'dir.kb.published': 'Publicat',
  'dir.kb.draft': 'Ciornă',
  'dir.kb.publish': 'Publică',
  'dir.kb.unpublish': 'Retrage publicarea',
  'dir.kb.noFolders': 'Niciun folder în această categorie',
  'dir.kb.noFoldersDescription': 'Adăugați un folder pentru a începe gruparea articolelor.',
  'dir.kb.articlesCount': '{count} articole',
  'dir.kb.fieldTitle': 'Titlu',
  'dir.kb.folder': 'Folder',
  'dir.kb.selectFolder': 'Selectează folderul',
  'dir.kb.content': 'Conținut',
  'dir.kb.contentPlaceholder': 'Scrieți conținutul articolului...',
  'dir.kb.tags': 'Etichete (separate prin virgulă)',
  'dir.kb.attachments': 'Atașamente',
  'dir.kb.download': 'Descarcă',
  'dir.kb.downloadFile': 'Descarcă {name}',
  'dir.kb.remove': 'Elimină',
  'dir.kb.removeFile': 'Elimină {name}',
  'dir.kb.noAttachments': 'Niciun atașament încă.',
  'dir.kb.uploadAria': 'Încarcă atașament',
  'dir.kb.uploading': 'Se încarcă...',
  'dir.kb.addFile': 'Adaugă fișier',
  'dir.kb.confirmDeleteTitle': 'Ștergeți articolul?',
  'dir.kb.confirmDeleteDescription': 'Acest articol, publicat sau ciornă, va fi șters definitiv.',
  'dir.kb.confirmDeleteLabel': 'Șterge articolul',
  'dir.kb.confirmRemoveTitle': 'Eliminați atașamentul?',
  'dir.kb.confirmRemoveDescription': 'Fișierul va fi eliminat definitiv din acest articol.',
  'dir.kb.confirmRemoveLabel': 'Elimină atașamentul',
  'dir.reports.rangeInvalid': 'Alegeți date de început și de sfârșit valide.',
  'dir.reports.rangeOrder': 'Data de sfârșit trebuie să fie egală sau ulterioară datei de început.',
  'dir.reports.rangeMax': 'Rapoartele acceptă un interval maxim de 90 de zile.',

  'adm.active': 'Activ',
  'adm.auto.action.add_tag': 'adaugă etichetă',
  'adm.auto.action.assign_agent': 'atribuie agent',
  'adm.auto.action.assign_group': 'atribuie grup',
  'adm.auto.action.send_email': 'trimite e-mail',
  'adm.auto.action.send_notification': 'trimite notificare',
  'adm.auto.action.set_priority': 'setează prioritatea',
  'adm.auto.action.set_status': 'setează starea',
  'adm.auto.actions': 'Acțiuni',
  'adm.auto.addAction': '+ Adaugă acțiune',
  'adm.auto.addCondition': '+ Adaugă condiție',
  'adm.auto.addRule': 'Adaugă regulă',
  'adm.auto.colApplied': 'Acțiuni aplicate',
  'adm.auto.colDate': 'Data',
  'adm.auto.colMatched': 'Potrivit',
  'adm.auto.colSubject': 'Subiect',
  'adm.auto.colTicket': 'Tichet',
  'adm.auto.conditions': 'Condiții',
  'adm.auto.confirmDesc': 'Această regulă se va opri imediat din rulare și nu poate fi restaurată.',
  'adm.auto.confirmLabel': 'Șterge regula',
  'adm.auto.confirmTitle': 'Ștergeți regula de automatizare?',
  'adm.auto.countMany': '{count} reguli de automatizare',
  'adm.auto.countOne': '{count} regulă de automatizare',
  'adm.auto.create': 'Creează',
  'adm.auto.createFirst': 'Creați prima regulă de automatizare',
  'adm.auto.createFirstDesc': 'Folosiți Adaugă regulă pentru a direcționa, prioritiza sau notifica automat.',
  'adm.auto.deleteFailed': 'Ștergerea a eșuat',
  'adm.auto.description': 'Regulile rulează secvențial, în ordinea poziției. Condițiile dintr-o regulă sunt combinate cu ȘI.',
  'adm.auto.editRule': 'Editează regula de automatizare',
  'adm.auto.execFailed': 'Nu s-au putut încărca execuțiile',
  'adm.auto.field.assigneeId': 'responsabil',
  'adm.auto.field.companyId': 'companie',
  'adm.auto.field.groupId': 'grup',
  'adm.auto.field.priority': 'prioritate',
  'adm.auto.field.requesterId': 'solicitant',
  'adm.auto.field.source': 'sursă',
  'adm.auto.field.status': 'stare',
  'adm.auto.field.subject': 'subiect',
  'adm.auto.field.ticketTypeId': 'tip de tichet',
  'adm.auto.hits': 'Potriviri',
  'adm.auto.loadFailed': 'Nu s-au putut încărca regulile de automatizare',
  'adm.auto.log': 'Jurnal',
  'adm.auto.logTitle': 'Jurnal de execuție — {name}',
  'adm.auto.moveDown': 'Mută în jos',
  'adm.auto.moveUp': 'Mută în sus',
  'adm.auto.newRule': 'Regulă de automatizare nouă',
  'adm.auto.no': 'Nu',
  'adm.auto.noRuns': 'Nicio rulare înregistrată încă',
  'adm.auto.noRunsDesc': 'Execuțiile apar aici prima dată când această regulă se potrivește cu un tichet.',
  'adm.auto.op.contains': 'conține',
  'adm.auto.op.ends_with': 'se termină cu',
  'adm.auto.op.greater_than': 'mai mare decât',
  'adm.auto.op.in': 'în',
  'adm.auto.op.is': 'este',
  'adm.auto.op.is_empty': 'este gol',
  'adm.auto.op.is_not': 'nu este',
  'adm.auto.op.is_not_empty': 'nu este gol',
  'adm.auto.op.less_than': 'mai mic decât',
  'adm.auto.op.not_contains': 'nu conține',
  'adm.auto.op.not_in': 'nu este în',
  'adm.auto.op.starts_with': 'începe cu',
  'adm.auto.reorderFailed': 'Reordonarea a eșuat',
  'adm.auto.saveFailed': 'Salvarea a eșuat',
  'adm.auto.stopProcessing': 'Oprește procesarea regulilor următoare',
  'adm.auto.title': 'Reguli de automatizare',
  'adm.auto.toggleFailed': 'Comutarea a eșuat',
  'adm.auto.trigger': 'Declanșator *',
  'adm.auto.trigger.ticket_creation': 'Crearea tichetului',
  'adm.auto.trigger.ticket_update': 'Actualizarea tichetului',
  'adm.auto.trigger.time_trigger': 'Bazat pe timp',
  'adm.auto.triggerCol': 'Declanșator',
  'adm.auto.valuePlaceholder': 'Valoare',
  'adm.auto.yes': 'Da',
  'adm.close': 'Închide',
  'adm.deleting': 'Se șterge...',
  'adm.description': 'Descriere',
  'adm.descriptionLabel': 'Descriere',
  'adm.edit': 'Editează',
  'adm.email.addChannel': 'Adaugă canal',
  'adm.email.addTitle': 'Adaugă canal de e-mail',
  'adm.email.colEmail': 'E-mail',
  'adm.email.colReplyTo': 'Răspuns către',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Acest canal nu va mai fi disponibil pentru e-mailurile de asistență.',
  'adm.email.confirmLabel': 'Șterge canalul',
  'adm.email.confirmTitle': 'Ștergeți canalul de e-mail?',
  'adm.email.countMany': '{count} canale de e-mail',
  'adm.email.countOne': '{count} canal de e-mail',
  'adm.email.create': 'Creează',
  'adm.email.createFirst': 'Adăugați primul canal de e-mail',
  'adm.email.createFirstDesc': 'Folosiți Adaugă canal pentru a conecta o adresă de asistență, astfel încât răspunsurile să ajungă la acest desk.',
  'adm.email.default': 'Implicit',
  'adm.email.defaultChannel': 'Canal implicit',
  'adm.email.deleteFailed': 'Ștergerea a eșuat',
  'adm.email.description': 'Gestionați adresele de e-mail de intrare/ieșire, configurația SMTP și setările de răspuns către.',
  'adm.email.editTitle': 'Editează canalul de e-mail',
  'adm.email.emailAddress': 'Adresă de e-mail *',
  'adm.email.loadFailed': 'Nu s-au putut încărca configurațiile de e-mail',
  'adm.email.outbound': 'SMTP de ieșire',
  'adm.email.replyTo': 'Adresă pentru răspuns',
  'adm.email.replyToPh': '(implicit adresa de e-mail)',
  'adm.email.saveFailed': 'Salvarea a eșuat',
  'adm.email.sesGlobal': 'SES (global)',
  'adm.email.smtpHost': 'Gazdă SMTP',
  'adm.email.smtpHostPh': 'ex. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Parolă SMTP',
  'adm.email.smtpPort': 'Port SMTP',
  'adm.email.smtpUser': 'Utilizator SMTP',
  'adm.email.title': 'Canale de e-mail',
  'adm.groups.aboutBody': 'Membrii determină ce agenți văd implicit tichetele acestui grup. Programul de lucru reglementează calculul SLA pentru tichetele direcționate aici, iar contactul de escaladare este notificat suplimentar față de responsabil când un tichet depășește SLA.',
  'adm.groups.aboutTitle': 'Despre acest grup',
  'adm.groups.accountDefault': 'Implicit al contului',
  'adm.groups.activeAgentMany': '{count} agenți activi',
  'adm.groups.activeAgentOne': '{count} agent activ',
  'adm.groups.activeAgents': 'Agenți activi',
  'adm.groups.addMember': 'Adaugă membru',
  'adm.groups.assignment': 'Atribuire',
  'adm.groups.autoAssign': 'Atribuire automată',
  'adm.groups.autoAssignNote': 'Atribuirea tichetelor este întotdeauna manuală în acest produs - nu există rutare round-robin sau bazată pe încărcare. Acest comutator nu schimbă acest lucru.',
  'adm.groups.businessHours': 'Program de lucru',
  'adm.groups.colGroup': 'Grup',
  'adm.groups.confirmDesc': 'Tichetele și șabloanele care folosesc acest grup trebuie mai întâi reatribuite.',
  'adm.groups.confirmLabel': 'Șterge grupul',
  'adm.groups.confirmTitle': 'Ștergeți „{name}”?',
  'adm.groups.createFirst': 'Creați primul grup',
  'adm.groups.defaultHours': 'Program implicit',
  'adm.groups.editAria': 'Editează {name}',
  'adm.groups.editGroup': 'Editează grupul',
  'adm.groups.escalateHelp': 'Adăugat ca destinatar al notificărilor când un tichet din acest grup depășește SLA.',
  'adm.groups.escalateTo': 'Escaladează către',
  'adm.groups.escalatesTo': 'Escaladează către',
  'adm.groups.escalatesToName': 'Escaladează către {name}',
  'adm.groups.escalationBody': 'Când un tichet din acest grup depășește SLA, contactul de escaladare este adăugat ca destinatar al notificărilor alături de responsabil și membrii grupului.',
  'adm.groups.escalationTitle': 'Contact de escaladare',
  'adm.groups.hoursHelp': 'Folosit pentru calculele SLA ale tichetelor din acest grup.',
  'adm.groups.manageAgents': 'Gestionează agenții',
  'adm.groups.manageHours': 'Gestionează programul de lucru',
  'adm.groups.manual': 'Manual',
  'adm.groups.manualBody': 'Atribuirea este manuală în acest produs - nu există atribuire automată round-robin sau bazată pe încărcare. Comutatorul „Atribuire automată” al unui grup afectează doar dacă tichetele noi din acel grup rămân neatribuite sau revin la o regulă de rutare existentă; agenții își preiau și își predau în continuare singuri tichetele.',
  'adm.groups.manualTitle': 'Atribuire manuală',
  'adm.groups.memberMany': '{count} membri',
  'adm.groups.memberOne': '{count} membru',
  'adm.groups.members': 'Membri',
  'adm.groups.newGroup': 'Grup nou',
  'adm.groups.noEscalation': 'Fără contact de escaladare',
  'adm.groups.noMatch': 'Niciun grup nu corespunde acestei căutări',
  'adm.groups.noMembers': 'Niciun membru încă',
  'adm.groups.noMembersDesc': 'Alegeți un agent activ mai sus și selectați Adaugă membru.',
  'adm.groups.remove': 'Elimină',
  'adm.groups.routing': 'Rutare',
  'adm.groups.routingMethod': 'Metodă de rutare',
  'adm.groups.saved': 'Grup salvat.',
  'adm.groups.searchAria': 'Caută grupuri',
  'adm.groups.searchPlaceholder': 'Caută după nume',
  'adm.groups.selectActiveAgent': 'Selectează agent activ',
  'adm.groups.showing': 'Se afișează {start}-{end} din {total}',
  'adm.groups.subtitle': 'Grupurile controlează rutarea și vizibilitatea tichetelor. Atribuiți agenți ca membri și alegeți un program de lucru și un contact de escaladare pentru fiecare grup.',
  'adm.groups.title': 'Grupuri',
  'adm.groups.tryDifferent': 'Încercați un alt nume de grup.',
  'adm.groups.unassigned': 'Neatribuit',
  'adm.groups.useNew': 'Folosiți Grup nou pentru a direcționa tichetele către un set de agenți.',
  'adm.groups.zero': '0 grupuri',
  'adm.inactive': 'Inactiv',
  'adm.jira.accepted': 'Conexiune acceptată',
  'adm.jira.accountEmail': 'E-mail cont Jira',
  'adm.jira.accountEmailLabel': 'E-mail cont',
  'adm.jira.activeConn': 'Conexiune activă',
  'adm.jira.addConnection': 'Adaugă conexiune',
  'adm.jira.addTitle': 'Adaugă conexiune Jira',
  'adm.jira.added': 'Conexiune Jira adăugată',
  'adm.jira.apiToken': 'Token API',
  'adm.jira.clearSecret': 'Șterge secretul webhook salvat',
  'adm.jira.confirmDesc': 'Aceasta elimină conexiunea salvată și legăturile ei cu tichetele. Problemele Jira nu sunt șterse.',
  'adm.jira.confirmLabel': 'Șterge conexiunea',
  'adm.jira.confirmTitle': 'Ștergeți {name}?',
  'adm.jira.connName': 'Nume conexiune',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Conectat ca {name}',
  'adm.jira.connectionDesk': 'Panou conexiuni',
  'adm.jira.default': 'Implicit',
  'adm.jira.defaultConn': 'Conexiune implicită',
  'adm.jira.defaultIssueType': 'Tip implicit de problemă',
  'adm.jira.defaultProjectKey': 'Cheie implicită de proiect',
  'adm.jira.defaults': 'Valori implicite',
  'adm.jira.description': 'Conectați site-uri Jira ale contului pentru ca agenții să poată asocia probleme și să păstreze starea tichetelor sincronizată.',
  'adm.jira.editTitle': 'Editează conexiunea Jira',
  'adm.jira.footer': 'Creați webhook-ul Jira cu endpoint-ul afișat mai sus, abonați-vă la evenimentele de actualizare a problemelor și folosiți același secret de webhook configurat aici.',
  'adm.jira.heading': 'Mențineți asistența și ingineria în același circuit',
  'adm.jira.intro': 'Datele de autentificare sunt stocate criptat pe server și nu sunt niciodată returnate în acest ecran. Configurați un secret de webhook atunci când Jira trebuie să trimită modificările de stare înapoi către SuzukiDesk.',
  'adm.jira.no': 'Nu',
  'adm.jira.noConns': 'Nicio conexiune Jira încă',
  'adm.jira.noConnsDesc': 'Adăugați o conexiune pentru a face acțiunile Jira disponibile din detaliile tichetului.',
  'adm.jira.noProject': 'Niciun proiect',
  'adm.jira.pasteToken': 'Lipiți tokenul',
  'adm.jira.requestFailed': 'Solicitarea Jira a eșuat. Încercați din nou.',
  'adm.jira.savedToast': 'Conexiune Jira salvată',
  'adm.jira.secretConfigured': 'Secret configurat: {value}',
  'adm.jira.secretHint': 'Folosiți același secret la crearea webhook-ului Jira.',
  'adm.jira.secretOptional': 'Opțional, minimum 16 caractere',
  'adm.jira.siteUrl': 'URL site Jira',
  'adm.jira.siteUrlHint': 'Nu includeți datele de autentificare în URL.',
  'adm.jira.syncFromJira': 'Starea Jira înapoi în tichet',
  'adm.jira.syncSnapshot': 'Instantaneu al problemei asociate',
  'adm.jira.syncToJira': 'Starea tichetului în Jira',
  'adm.jira.testConnection': 'Testează conexiunea',
  'adm.jira.testFailed': 'Testul conexiunii a eșuat',
  'adm.jira.title': 'Integrare Jira',
  'adm.jira.tokenHintEdit': 'Lăsați gol pentru a păstra tokenul curent.',
  'adm.jira.tokenHintNew': 'Stocat criptat; nu va mai fi afișat.',
  'adm.jira.tokenMissing': 'Token API lipsă',
  'adm.jira.tokenStored': 'Token API stocat',
  'adm.jira.unchanged': '(nemodificat dacă este gol)',
  'adm.jira.verified': 'Conexiune Jira verificată',
  'adm.jira.webhookEndpoint': 'Endpoint webhook Jira',
  'adm.jira.webhookSecret': 'Secret webhook',
  'adm.jira.whatSyncs': 'Ce se sincronizează',
  'adm.jira.yes': 'Da',
  'adm.nameRequired': 'Nume *',
  'adm.nextPage': 'Pagina următoare',
  'adm.notif.aud.all': 'Partajat',
  'adm.notif.aud.customer': 'Client',
  'adm.notif.aud.internal': 'Intern',
  'adm.notif.audEmail': 'E-mail {audience}',
  'adm.notif.body': 'Conținut',
  'adm.notif.description': 'Personalizați fiecare audiență a notificărilor fără a trimite clienții în spațiul de lucru intern.',
  'adm.notif.discardDesc': 'Modificările nesalvate ale acestui șablon de notificare se vor pierde dacă schimbați șablonul.',
  'adm.notif.discardLabel': 'Renunță la modificări',
  'adm.notif.discardTitle': 'Renunțați la modificările nesalvate?',
  'adm.notif.discarded': 'Modificările nesalvate au fost eliminate.',
  'adm.notif.event.automation_notification': 'Notificare de automatizare',
  'adm.notif.event.group_member_added': 'Adăugat în grup',
  'adm.notif.event.mention': 'Mențiune',
  'adm.notif.event.pending_input': 'Așteaptă răspuns',
  'adm.notif.event.sla_breach': 'Depășire SLA',
  'adm.notif.event.sla_escalation': 'Escaladare SLA',
  'adm.notif.event.sla_warning': 'Avertisment SLA',
  'adm.notif.event.ticket_assigned': 'Tichet atribuit',
  'adm.notif.event.ticket_created': 'Tichet creat',
  'adm.notif.event.ticket_first_response': 'Primul răspuns',
  'adm.notif.event.ticket_group_assigned': 'Tichet atribuit grupului',
  'adm.notif.event.ticket_note': 'Notă privată',
  'adm.notif.event.ticket_public_note': 'Notă publică',
  'adm.notif.event.ticket_reply': 'Răspuns la tichet',
  'adm.notif.event.ticket_resolved': 'Tichet rezolvat',
  'adm.notif.events': 'Evenimente',
  'adm.notif.eventsHelp': 'Alegeți un eveniment și audiența destinatarilor.',
  'adm.notif.insertVar': 'Inserează {variable}',
  'adm.notif.linkNoteAgent': 'Variabila de link {variable}, care ține cont de audiență, deschide spațiul de lucru al agentului pentru acest e-mail.',
  'adm.notif.linkNoteCustomer': 'Variabila de link {variable}, care ține cont de audiență, deschide portalul clientului pentru acest e-mail.',
  'adm.notif.off': 'oprit',
  'adm.notif.preview': 'Previzualizare',
  'adm.notif.previewNotice': 'Previzualizare generată cu date de exemplu.',
  'adm.notif.rendering': 'Se generează…',
  'adm.notif.route.all': 'Folosește linkul tichetului adaptat destinatarului pentru audiența de livrare.',
  'adm.notif.route.customer': 'Acțiunea principală deschide tichetul în portalul clientului.',
  'adm.notif.route.internal': 'Acțiunea principală deschide tichetul în spațiul de lucru al agentului.',
  'adm.notif.sampleOnlyAgent': 'Doar date de exemplu — acțiunea principală vizează ruta spațiului de lucru al agentului.',
  'adm.notif.sampleOnlyCustomer': 'Doar date de exemplu — acțiunea principală vizează ruta portalului clientului.',
  'adm.notif.saveChanges': 'Salvează modificările',
  'adm.notif.saved': 'Șablon salvat.',
  'adm.notif.savedBtn': 'Salvat',
  'adm.notif.selectEvent': 'Selectați un eveniment pentru a-i edita șablonul',
  'adm.notif.selectEventDesc': 'Alegeți un eveniment de notificare din stânga pentru a-i modifica subiectul și conținutul.',
  'adm.notif.sendTest': 'Trimite e-mail de test',
  'adm.notif.sending': 'Se trimite…',
  'adm.notif.subject': 'Subiect',
  'adm.notif.testQueued': 'E-mailul de test a fost pus în coadă către {email}.',
  'adm.notif.title': 'Șabloane de notificare',
  'adm.notif.urlVarTitle': 'Variabilă de link adaptată audienței',
  'adm.notif.useTemplate': 'Folosește acest șablon pentru această audiență',
  'adm.notif.useTemplateHelp': 'Dezactivarea lui folosește notificarea sigură de rezervă.',
  'adm.notif.variables': 'Variabile',
  'adm.notif.variablesHelp': 'Faceți clic pentru a adăuga la conținutul mesajului',
  'adm.pagination': 'Paginare',
  'adm.perm.cap.admin.label': 'Acces la consola de administrare',
  'adm.perm.cap.assign.label': 'Atribuire tichet',
  'adm.perm.cap.close.label': 'Închidere tichet',
  'adm.perm.cap.conversation_delete.label': 'Ștergerea unui răspuns sau a unei note postate',
  'adm.perm.cap.conversation_edit.label': 'Editarea unui răspuns sau a unei note postate',
  'adm.perm.cap.create.label': 'Creare tichet',
  'adm.perm.cap.delete.label': 'Ștergere tichet',
  'adm.perm.cap.edit.label': 'Editarea proprietăților tichetului',
  'adm.perm.cap.export.label': 'Exportul tichetelor',
  'adm.perm.cap.field_admin.label': 'Câmpuri tichet',
  'adm.perm.cap.form_admin.label': 'Formulare tichet',
  'adm.perm.cap.forward.label': 'Redirecționare tichet',
  'adm.perm.cap.jira_link.label': 'Asocierea și gestionarea problemelor Jira',
  'adm.perm.cap.kb.label': 'Acces la baza de cunoștințe',
  'adm.perm.cap.manage_agents.label': 'Agenți',
  'adm.perm.cap.manage_api_keys.label': 'Chei API',
  'adm.perm.cap.manage_automations.label': 'Automatizări',
  'adm.perm.cap.manage_canned_responses.label': 'Răspunsuri predefinite',
  'adm.perm.cap.manage_email_config.label': 'E-mail',
  'adm.perm.cap.manage_groups.label': 'Grupuri',
  'adm.perm.cap.manage_jira.label': 'Integrare Jira',
  'adm.perm.cap.manage_kb.label': 'Bază de cunoștințe',
  'adm.perm.cap.manage_notification_templates.label': 'Șabloane de notificare',
  'adm.perm.cap.manage_roles.label': 'Roluri',
  'adm.perm.cap.manage_tags.label': 'Etichete',
  'adm.perm.cap.note.label': 'Adăugarea sau editarea notelor private',
  'adm.perm.cap.reassign.label': 'Reatribuirea unui tichet deținut deja de altcineva',
  'adm.perm.cap.reopen.label': 'Redeschiderea unui tichet rezolvat sau închis',
  'adm.perm.cap.reply.label': 'Răspuns public către client',
  'adm.perm.cap.report_access.label': 'Vizualizarea rapoartelor și a tablourilor de bord',
  'adm.perm.cap.reports.label': 'Acces la modulul de raportare',
  'adm.perm.cap.resolve.label': 'Rezolvare tichet',
  'adm.perm.cap.settings_admin.label': 'Deschiderea secțiunii Setări (necesar pentru a vedea elementul de navigare Setări și pagina sa de index; accesul la fiecare pagină de mai jos rămâne controlat independent)',
  'adm.perm.cap.sla_admin.label': 'Politici SLA și program de lucru',
  'adm.perm.cap.sla_edit.desc': 'Separat de permisiunea Setări > Politici SLA de mai jos — aceasta acoperă doar editarea datelor scadente ale unui tichet individual.',
  'adm.perm.cap.sla_edit.label': 'Suprascrierea manuală a datelor scadente SLA ale unui tichet',
  'adm.perm.cap.tag.label': 'Gestionarea etichetelor tichetelor',
  'adm.perm.cap.thread_start.label': 'Începerea unui fir privat la o intrare de conversație',
  'adm.perm.cap.tickets.label': 'Acces la spațiul de lucru al tichetelor',
  'adm.perm.cap.view.label': 'Vizualizarea tichetelor din domeniu',
  'adm.perm.cat.administration.desc': 'Acces la consola de administrare și la ecranele sale de configurare.',
  'adm.perm.cat.administration.label': 'Administrare',
  'adm.perm.cat.knowledge.desc': 'Citirea și folosirea conținutului de cunoștințe în timpul lucrului la un tichet.',
  'adm.perm.cat.knowledge.label': 'Bază de cunoștințe',
  'adm.perm.cat.reporting.desc': 'Raportare operațională și tablouri de bord.',
  'adm.perm.cat.reporting.label': 'Raportare',
  'adm.perm.cat.settings-pages.desc': 'Acordați acces individual la fiecare ecran Setări. Nimic nu este vizibil până nu este bifat explicit aici.',
  'adm.perm.cat.settings-pages.label': 'Pagini de setări',
  'adm.perm.cat.tickets.desc': 'Ce poate face un agent în spațiul de lucru al tichetelor.',
  'adm.perm.cat.tickets.label': 'Tichete',
  'adm.previousPage': 'Pagina anterioară',
  'adm.refresh': 'Reîmprospătează',
  'adm.roleType.administrator': 'Administrator',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Colaborator',
  'adm.roleType.customer': 'Client',
  'adm.roleType.super_admin': 'Super administrator',
  'adm.roleType.supervisor': 'Supervizor',
  'adm.roles.activeHelp': 'Activ - rolurile inactive nu pot fi atribuite agenților',
  'adm.roles.agentCan': 'Agentul poate',
  'adm.roles.agentType': 'Tip agent',
  'adm.roles.agentsAssignedNote': 'Agenții primesc acest rol din ecranul Agenți.',
  'adm.roles.agentsCount': '{count} agenți',
  'adm.roles.agentsLabel': 'Agenți',
  'adm.roles.agentsManage': '{count} agenți - Gestionează',
  'adm.roles.builtIn': '(Integrat)',
  'adm.roles.builtInNote': 'Acesta este un rol integrat. Poate fi redenumit și dezactivat, dar nu poate fi șters.',
  'adm.roles.builtInTitle': 'Rol integrat: poate fi editat și dezactivat, dar nu poate fi șters',
  'adm.roles.categoriesAria': 'Categorii de permisiuni',
  'adm.roles.confirmDesc': 'Agenții atribuiți acestui rol vor avea nevoie de alt rol înainte ca acesta să poată fi eliminat.',
  'adm.roles.confirmLabel': 'Șterge rolul',
  'adm.roles.createFirst': 'Creați primul rol',
  'adm.roles.createFirstDesc': 'Folosiți Rol nou pentru a defini capabilitățile pe care ar trebui să le primească agenții.',
  'adm.roles.editRole': 'Editează rolul',
  'adm.roles.granted': '{count} acordate',
  'adm.roles.heading': 'Roluri de agent',
  'adm.roles.inactive': 'Inactiv',
  'adm.roles.newRole': 'Rol nou',
  'adm.roles.noAgent': 'Niciun agent',
  'adm.roles.notEnforced': '(încă neaplicat)',
  'adm.roles.notEnforcedTitle': 'Stocat în rol, dar încă nefolosit ca restricție la execuție',
  'adm.roles.permissions': 'Permisiuni',
  'adm.roles.saved': 'Rol salvat.',
  'adm.roles.scopeBody': 'Capabilitățile se combină cu domeniul la nivel de rând (toate / grup / atribuite / proprii), astfel încât un agent acționează doar asupra tichetelor pe care le poate deja vedea.',
  'adm.roles.scopeTitle': 'Domeniul se aplică în continuare',
  'adm.roles.scrollTo': 'Derulează la',
  'adm.roles.status': 'Stare',
  'adm.roles.subtitle': 'Oferiți și restricționați niveluri detaliate de acces și privilegii pentru agenți.',
  'adm.roles.title': 'Roluri',
  'adm.roles.typeLocked': 'Tipul agentului nu poate fi schimbat după salvarea rolului.',
  'adm.roles.understandingBody1': 'Rolurile stabilesc ce poate face un agent. Creați un rol, bifați capabilitățile pe care ar trebui să le acorde, apoi atribuiți-l agenților din ecranul Agenți.',
  'adm.roles.understandingBody2': 'Rolurile integrate pot fi redenumite și dezactivate, dar niciodată șterse. Nici un rol care are încă agenți atribuiți nu poate fi șters, așa că mutați mai întâi acești agenți.',
  'adm.roles.understandingTitle': 'Înțelegerea rolurilor',
  'adm.saveChanges': 'Salvează modificările',
  'adm.settings.add': 'Adaugă {name}',
  'adm.settings.back': 'Înapoi la setări',
  'adm.settings.cannedDesc': 'Răspunsurile contului disponibile pentru dvs. în timpul lucrului la un tichet.',
  'adm.settings.cannedEmpty': 'Niciun răspuns predefinit încă',
  'adm.settings.cannedEmptyDesc': 'Rugați un administrator să adauge răspunsuri partajate pe care echipa dvs. să le reutilizeze într-un tichet.',
  'adm.settings.cannedTitle': 'Răspunsuri predefinite',
  'adm.settings.col.autoAssign': 'Atribuire automată',
  'adm.settings.col.color': 'Culoare',
  'adm.settings.col.content': 'Conținut',
  'adm.settings.col.createdAt': 'Creat la',
  'adm.settings.col.description': 'Descriere',
  'adm.settings.col.email': 'E-mail',
  'adm.settings.col.expiresAt': 'Expiră la',
  'adm.settings.col.fieldType': 'Tip câmp',
  'adm.settings.col.firstName': 'Prenume',
  'adm.settings.col.folderId': 'ID folder',
  'adm.settings.col.hitCount': 'Număr de accesări',
  'adm.settings.col.holidays': 'Sărbători legale',
  'adm.settings.col.host': 'Gazdă',
  'adm.settings.col.hours': 'Ore',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Este activ',
  'adm.settings.col.isBuiltIn': 'Este integrat',
  'adm.settings.col.isDefault': 'Este implicit',
  'adm.settings.col.isRequired': 'Este obligatoriu',
  'adm.settings.col.isShared': 'Este partajat',
  'adm.settings.col.isSystem': 'Este de sistem',
  'adm.settings.col.key': 'Cheie',
  'adm.settings.col.label': 'Etichetă',
  'adm.settings.col.language': 'Limbă',
  'adm.settings.col.lastName': 'Nume',
  'adm.settings.col.lastUsedAt': 'Ultima utilizare',
  'adm.settings.col.name': 'Nume',
  'adm.settings.col.options': 'Opțiuni',
  'adm.settings.col.phone': 'Telefon',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Poziție',
  'adm.settings.col.prefix': 'Prefix',
  'adm.settings.col.priority': 'Prioritate',
  'adm.settings.col.required': 'Obligatoriu',
  'adm.settings.col.role': 'Rol',
  'adm.settings.col.roleId': 'ID rol',
  'adm.settings.col.scopes': 'Domenii',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Stare',
  'adm.settings.col.stopProcessing': 'Oprește procesarea',
  'adm.settings.col.timezone': 'Fus orar',
  'adm.settings.col.title': 'Titlu',
  'adm.settings.col.trigger': 'Declanșator',
  'adm.settings.col.type': 'Tip',
  'adm.settings.col.updatedAt': 'Actualizat la',
  'adm.settings.col.usageCount': 'Număr de utilizări',
  'adm.settings.col.username': 'Nume de utilizator',
  'adm.settings.confirmDesc': 'Această acțiune nu poate fi anulată.',
  'adm.settings.confirmTitle': 'Ștergeți {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Creează',
  'adm.settings.empty': 'Niciun element {title} încă',
  'adm.settings.emptyAdd': 'Folosiți formularul de mai sus pentru a adăuga primul {name}.',
  'adm.settings.emptyOther': 'Intrările apar aici după ce sunt configurate.',
  'adm.settings.homeDesc': 'Configurați utilizatori, fluxuri de lucru pentru tichete, niveluri de serviciu și integrări.',
  'adm.settings.manage': 'Gestionează {title}.',
  'adm.settings.noPages': 'Nicio pagină de setări disponibilă',
  'adm.settings.noPagesDesc': 'Rugați un super administrator să vă acorde acces la paginile de setări de care aveți nevoie.',
  'adm.settings.notFound': 'Pagina de setări nu a fost găsită',
  'adm.settings.notFoundDesc': 'Alegeți o zonă de setări pentru a continua.',
  'adm.settings.res.agents.field.email': 'E-mail',
  'adm.settings.res.agents.field.firstName': 'Prenume',
  'adm.settings.res.agents.field.lastName': 'Nume',
  'adm.settings.res.agents.field.password': 'Parolă temporară',
  'adm.settings.res.agents.field.roleId': 'ID rol',
  'adm.settings.res.agents.one': 'agent',
  'adm.settings.res.agents.title': 'Agenți',
  'adm.settings.res.api-keys.field.name': 'Nume cheie',
  'adm.settings.res.api-keys.one': 'cheie API',
  'adm.settings.res.api-keys.title': 'Chei API',
  'adm.settings.res.automations.field.description': 'Descriere',
  'adm.settings.res.automations.field.name': 'Nume',
  'adm.settings.res.automations.one': 'automatizare',
  'adm.settings.res.automations.title': 'Automatizări',
  'adm.settings.res.business-hours.field.name': 'Nume',
  'adm.settings.res.business-hours.field.timezone': 'Fus orar',
  'adm.settings.res.business-hours.one': 'program de lucru',
  'adm.settings.res.business-hours.title': 'Program de lucru',
  'adm.settings.res.canned-responses.field.content': 'Conținutul răspunsului',
  'adm.settings.res.canned-responses.field.title': 'Titlu',
  'adm.settings.res.canned-responses.one': 'răspuns predefinit',
  'adm.settings.res.canned-responses.title': 'Răspunsuri predefinite',
  'adm.settings.res.email.field.host': 'Gazdă SMTP',
  'adm.settings.res.email.field.name': 'Nume',
  'adm.settings.res.email.field.port': 'Port SMTP',
  'adm.settings.res.email.field.username': 'Nume de utilizator',
  'adm.settings.res.email.one': 'configurație de e-mail',
  'adm.settings.res.email.title': 'Configurație e-mail',
  'adm.settings.res.fields.one': 'câmp de tichet',
  'adm.settings.res.fields.title': 'Câmpuri tichet',
  'adm.settings.res.forms.field.label': 'Etichetă afișată',
  'adm.settings.res.forms.field.name': 'Nume câmp',
  'adm.settings.res.forms.field.type': 'Tip câmp',
  'adm.settings.res.forms.one': 'formular sau câmp personalizat',
  'adm.settings.res.forms.title': 'Formulare și câmpuri personalizate',
  'adm.settings.res.groups.field.description': 'Descriere',
  'adm.settings.res.groups.field.name': 'Nume',
  'adm.settings.res.groups.one': 'grup',
  'adm.settings.res.groups.title': 'Grupuri',
  'adm.settings.res.jira.one': 'integrare Jira',
  'adm.settings.res.jira.title': 'Integrare Jira',
  'adm.settings.res.kb.field.content': 'Conținutul articolului',
  'adm.settings.res.kb.field.folderId': 'ID folder',
  'adm.settings.res.kb.field.title': 'Titlul articolului',
  'adm.settings.res.kb.one': 'articol din baza de cunoștințe',
  'adm.settings.res.kb.title': 'Administrarea bazei de cunoștințe',
  'adm.settings.res.notification-templates.one': 'șablon de notificare',
  'adm.settings.res.notification-templates.title': 'Șabloane de notificare',
  'adm.settings.res.roles.field.description': 'Descriere',
  'adm.settings.res.roles.field.name': 'Nume',
  'adm.settings.res.roles.field.type': 'Tip rol',
  'adm.settings.res.roles.one': 'rol',
  'adm.settings.res.roles.title': 'Roluri',
  'adm.settings.res.sla.field.description': 'Descriere',
  'adm.settings.res.sla.field.name': 'Nume',
  'adm.settings.res.sla.one': 'politică SLA',
  'adm.settings.res.sla.title': 'Politici SLA',
  'adm.settings.res.tags.field.name': 'Nume',
  'adm.settings.res.tags.one': 'etichetă',
  'adm.settings.res.tags.title': 'Etichete',
  'adm.settings.title': 'Setări',
  'adm.status': 'Stare',

  'sla.edit': 'Editează',
  'sla.active': 'Activ',
  'sla.inactive': 'Inactiv',
  'sla.default': 'Implicit',
  'sla.yes': 'Da',
  'sla.no': 'Nu',
  'sla.description': 'Descriere',
  'sla.status': 'Stare',
  'sla.notConfigured': 'Neconfigurat',
  'sla.minutesValue': '{value} minute',
  'sla.invalidServerValue': 'Valoare server nevalidă',
  'sla.statusSemantics.title': 'Semantica stării tichetului',
  'sla.statusSemantics.description': 'Fiecare stare activă are un contract SLA explicit. O stare care pune SLA în pauză și o stare care oprește SLA se exclud reciproc.',
  'sla.statusSemantics.conflict': 'O stare nu poate pune SLA în pauză și îl poate opri în același timp.',
  'sla.statusSemantics.emptyTitle': 'Nicio definiție de stare',
  'sla.statusSemantics.emptyDescription': 'Definițiile stărilor vor apărea aici după ce sunt configurate pentru acest cont.',
  'sla.statusSemantics.colPauses': 'Pune SLA în pauză',
  'sla.statusSemantics.colStops': 'Oprește SLA',
  'sla.statusSemantics.pausesAria': '{label} pune SLA în pauză',
  'sla.statusSemantics.stopsAria': '{label} oprește SLA',
  'sla.preview.title': 'Previzualizare tichet doar pentru citire',
  'sla.preview.description': 'Rulați același evaluator la nivel de cont folosit de ciclurile SLA live. Această previzualizare nu scrie niciodată o politică sau un tichet.',
  'sla.preview.priority': 'Prioritate',
  'sla.preview.group': 'Grup',
  'sla.preview.anyGroup': 'Orice grup',
  'sla.preview.company': 'Companie',
  'sla.preview.anyCompany': 'Orice companie',
  'sla.preview.source': 'Sursă',
  'sla.preview.anySource': 'Orice sursă',
  'sla.preview.ticketType': 'Tip de tichet',
  'sla.preview.anyTicketType': 'Orice tip de tichet',
  'sla.preview.representativeStart': 'Început reprezentativ',
  'sla.preview.calculating': 'Se calculează…',
  'sla.preview.run': 'Rulează previzualizarea',
  'sla.preview.configAttention': 'Configurația necesită atenție',
  'sla.preview.selectedPolicy': 'Politică selectată',
  'sla.preview.noPolicy': 'Nicio politică',
  'sla.preview.evaluationOrder': 'Ordinea de evaluare',
  'sla.preview.firstMatching': 'Prima politică potrivită',
  'sla.preview.calculationMode': 'Mod de calcul',
  'sla.preview.modeBusinessHours': 'Program de lucru',
  'sla.preview.modeBusinessHoursNamed': 'Program de lucru · {name}',
  'sla.preview.mode247': 'Timp scurs 24/7',
  'sla.preview.modeNone': 'Necalculat',
  'sla.preview.thresholds': 'Praguri independente',
  'sla.preview.colMetric': 'Indicator',
  'sla.preview.colTarget': 'Țintă',
  'sla.preview.colWarning': 'Avertisment',
  'sla.preview.colDue': 'Scadență / depășire',
  'sla.preview.colEscalation': 'Escaladare',
  'sla.preview.colState': 'Stare',
  'sla.preview.metricFirstResponse': 'Primul răspuns',
  'sla.preview.metricResolution': 'Rezolvare',
  'sla.preview.trace': 'Urma evaluării politicilor',
  'sla.preview.selected': 'Selectată',
  'sla.preview.matchedAfterSelection': 'Potrivită după selecție',
  'sla.preview.skipped': 'Omisă',
  'sla.preview.showTrace': 'Afișează urma calculului',
  'sla.state.not_configured': 'neconfigurat',
  'sla.state.running': 'în desfășurare',
  'sla.state.paused': 'în pauză',
  'sla.state.warning': 'avertisment',
  'sla.state.breached': 'depășit',
  'sla.state.met': 'respectat',
  'sla.state.escalated': 'escaladat',
  'sla.state.pending': 'în așteptare',
  'sla.state.stopped': 'oprit',
  'sla.state.on_track': 'pe drumul cel bun',
  'sla.state.at_risk': 'la risc',
  'sla.list.subtitle': 'Setați ținte pentru primul răspuns și rezolvare pentru fiecare prioritate. Politicile sunt evaluate de sus în jos — prima ale cărei condiții se potrivesc unui tichet câștigă.',
  'sla.list.newPolicy': 'Politică nouă',
  'sla.list.emptyTitle': 'Creați prima politică SLA',
  'sla.list.emptyDescription': 'Folosiți Politică nouă pentru a seta ținte de prim răspuns și rezolvare pentru fiecare prioritate.',
  'sla.list.moveUp': 'Mută în sus',
  'sla.list.moveDown': 'Mută în jos',
  'sla.list.frShort': 'PR: {value}',
  'sla.list.resolveShort': 'Rezolvare: {value}',
  'sla.list.escalateShort': 'Escaladare: +{value}',
  'sla.list.deactivate': 'Dezactivează',
  'sla.list.activate': 'Activează',
  'sla.list.setDefault': 'Setează ca implicită',
  'sla.list.duplicate': 'Duplică',
  'sla.list.deleteTitle': 'Ștergeți „{name}”?',
  'sla.list.deleteDescription': 'Tichetele asociate acestei politici vor folosi următoarea politică SLA disponibilă.',
  'sla.list.deleteConfirm': 'Șterge politica',
  'sla.conditions.groups': '{count} grup(uri)',
  'sla.conditions.companies': '{count} companie/companii',
  'sla.conditions.sources': 'surse: {list}',
  'sla.conditions.ticketTypes': '{count} tip(uri) de tichet',
  'sla.conditions.anyOf': 'oricare dintre',
  'sla.conditions.allOf': 'toate dintre',
  'sla.conditions.summary': 'Condiții ({mode}): {parts}',
  'sla.edit.newTitle': 'Politică SLA nouă',
  'sla.edit.editTitle': 'Editează politica SLA',
  'sla.edit.saved': 'Politică SLA salvată.',
  'sla.edit.name': 'Nume',
  'sla.edit.appliesToPriority': 'Se aplică prioritații',
  'sla.edit.evaluationOrder': 'Ordinea de evaluare',
  'sla.edit.evaluationOrderHint': 'Pozițiile mai mici sunt evaluate primele pentru acest cont.',
  'sla.edit.defaultPolicy': 'Politică implicită',
  'sla.edit.useAsDefault': 'Folosește ca implicită când nicio altă politică nu se potrivește',
  'sla.edit.targets': 'Ținte SLA',
  'sla.edit.firstResponse': 'Primul răspuns',
  'sla.edit.resolution': 'Rezolvare',
  'sla.edit.autoAt75': 'Automat la 75%',
  'sla.edit.enabledAfter': 'Activat după {value}',
  'sla.edit.clearEscalation': 'Șterge explicit ținta de escaladare',
  'sla.edit.clearEscalationHint': 'Trimite null; dacă această opțiune rămâne nebifată, câmpul este omis și valoarea salvată este păstrată.',
  'sla.edit.firstResponseMinutes': 'Primul răspuns (minute)',
  'sla.edit.resolutionMinutes': 'Rezolvare (minute)',
  'sla.edit.escalateAfter': 'Escaladează după (minute după scadența rezolvării)',
  'sla.edit.notSet': 'Nesetat',
  'sla.edit.remindersNote': 'Mementourile se declanșează automat la 75% din ferestrele de prim răspuns și rezolvare. Escaladarea notifică agentul de escaladare al grupului tichetului (setat pe grup) după ce ținta de rezolvare a fost depășită cu numărul configurat de minute.',
  'sla.edit.conditions': 'Condiții',
  'sla.edit.conditionsHint': 'Lăsați un grup nebifat pentru a se potrivi cu toate valorile',
  'sla.edit.matchMode': 'Mod de potrivire:',
  'sla.edit.matchAll': 'Potrivește TOATE condițiile',
  'sla.edit.matchAny': 'Potrivește ORICARE condiție',
  'sla.edit.groups': 'Grupuri',
  'sla.edit.companies': 'Companii',
  'sla.edit.sources': 'Surse',
  'sla.edit.ticketTypes': 'Tipuri de tichet',
  'sla.bh.subtitle': 'Definiți programul săptămânal și calendarul sărbătorilor folosite de politicile SLA pentru a calcula datele scadente.',
  'sla.bh.newCalendar': 'Calendar nou',
  'sla.bh.emptyTitle': 'Creați primul calendar de program de lucru',
  'sla.bh.emptyDescription': 'Folosiți Calendar nou pentru a defini programul săptămânal după care se calculează politicile SLA.',
  'sla.bh.accountDefault': 'Implicit al contului',
  'sla.bh.closedEveryDay': 'Închis în fiecare zi',
  'sla.bh.openEveryDay': 'Deschis în fiecare zi',
  'sla.bh.openDaysOne': 'Deschis 1 zi/săptămână',
  'sla.bh.openDaysMany': 'Deschis {count} zile/săptămână',
  'sla.bh.holidayOne': '1 sărbătoare',
  'sla.bh.holidayMany': '{count} sărbători',
  'sla.bh.deleteTitle': 'Ștergeți „{name}”?',
  'sla.bh.deleteDescription': 'Politicile SLA și grupurile care folosesc acest program vor reveni la valoarea implicită a contului.',
  'sla.bh.deleteConfirm': 'Șterge programul',
  'sla.bh.newTitle': 'Calendar nou de program de lucru',
  'sla.bh.editTitle': 'Editează programul de lucru',
  'sla.bh.saved': 'Program de lucru salvat.',
  'sla.bh.timezone': 'Fus orar',
  'sla.bh.defaultCalendar': 'Calendar implicit',
  'sla.bh.useAsDefault': 'Folosește pentru politicile SLA și grupurile care nu specifică propriul calendar',
  'sla.bh.weeklySchedule': 'Program săptămânal',
  'sla.bh.colDay': 'Zi',
  'sla.bh.colOpen': 'Deschis',
  'sla.bh.colStart': 'Început',
  'sla.bh.colEnd': 'Sfârșit',
  'sla.bh.dayOpenAria': '{day} deschis',
  'sla.bh.dayStartAria': 'Ora de început {day}',
  'sla.bh.dayEndAria': 'Ora de sfârșit {day}',
  'sla.bh.holidayCalendar': 'Calendarul sărbătorilor',
  'sla.bh.saveFirst': 'Salvați mai întâi acest calendar, apoi adăugați sărbători.',
  'sla.bh.holidayName': 'Numele sărbătorii',
  'sla.bh.date': 'Data',
  'sla.bh.addHoliday': 'Adaugă sărbătoare',
  'sla.bh.noHolidays': 'Nicio sărbătoare încă',
  'sla.bh.noHolidaysHint': 'Adăugați mai sus o sărbătoare cu dată pentru a o exclude din calculele SLA.',
  'sla.bh.remove': 'Elimină',
  'sla.day.monday': 'Luni',
  'sla.day.tuesday': 'Marți',
  'sla.day.wednesday': 'Miercuri',
  'sla.day.thursday': 'Joi',
  'sla.day.friday': 'Vineri',
  'sla.day.saturday': 'Sâmbătă',
  'sla.day.sunday': 'Duminică',

  'set.ftype.single_line_text': 'Text pe o singură linie',
  'set.ftype.multi_line_text': 'Text pe mai multe linii',
  'set.ftype.dropdown': 'Listă derulantă',
  'set.ftype.checkbox': 'Casetă de selectare',
  'set.ftype.radio': 'Buton radio',
  'set.ftype.multiselect': 'Selecție multiplă',
  'set.ftype.lookup': 'Relație de căutare',
  'set.ftype.dependent': 'Câmp dependent',
  'set.ftype.date': 'Dată',
  'set.ftype.number': 'Număr',
  'set.ftype.decimal': 'Zecimal',
  'set.ftype.desc.lookup': 'Selectați o înregistrare dintr-o sursă de sistem.',
  'set.ftype.desc.single_line_text': 'Valoare text scurtă.',
  'set.ftype.desc.multi_line_text': 'Valoare text lungă.',
  'set.ftype.desc.checkbox': 'Valoare adevărat sau fals.',
  'set.ftype.desc.dropdown': 'Selectați o opțiune normalizată.',
  'set.ftype.desc.dependent': 'Opțiunile depind de un câmp părinte.',
  'set.ftype.desc.date': 'Valoare de dată calendaristică.',
  'set.ftype.desc.number': 'Valoare numerică întreagă.',
  'set.ftype.desc.decimal': 'Valoare numerică zecimală.',
  'set.src.STATIC': 'Opțiuni statice',
  'set.src.AGENTS': 'Agenți',
  'set.src.USERS': 'Utilizatori / Clienți',
  'set.src.GROUPS': 'Grupuri',
  'set.src.ROLE': 'Roluri',
  'set.src.COUNTRIES': 'Țări',
  'set.src.CUSTOM': 'Listă derulantă personalizată',
  'set.settings': 'Setări',
  'set.ticketFields': 'Câmpuri tichet',
  'set.ticketForms': 'Formulare tichet',
  'set.requestFailed': 'Solicitarea a eșuat. Încercați din nou.',
  'set.refresh': 'Reîmprospătează',
  'set.saving': 'Se salvează…',
  'set.saveChanges': 'Salvează modificările',
  'set.default': 'Implicit',
  'set.published': 'Publicat',
  'set.draft': 'Ciornă',
  'set.publish': 'Publică',
  'set.unpublish': 'Retrage publicarea',
  'set.deleteForm': 'Șterge formularul',
  'set.description': 'Descriere',
  'set.relationshipSource': 'Sursa relației',
  'set.dependsOn': 'Depinde de {field}',
  'set.deleteFormTitle': 'Ștergeți „{name}”?',
  'set.deleteFormDescription': 'Acest formular de tichet și configurația sa vor fi șterse definitiv.',
  'set.formIdRequired': 'Este necesar un ID de formular.',
  'set.formNotFound': 'Formularul de tichet nu a fost găsit.',
  'set.tf.removeOption': 'Elimină {label}',
  'set.tf.noOptions': 'Nicio opțiune definită încă.',
  'set.tf.addOptionPlaceholder': 'Adaugă opțiune...',
  'set.tf.add': 'Adaugă',
  'set.tf.dependsOnField': 'Depinde de câmpul',
  'set.tf.selectParent': '— Selectați câmpul părinte —',
  'set.tf.parentHelp': 'Câmpul de listă derulantă părinte a cărui valoare selectată determină opțiunile disponibile ale acestui câmp.',
  'set.tf.optionMappings': 'Mapări de opțiuni',
  'set.tf.savingParen': '(se salvează...)',
  'set.tf.mappingsError': 'Nu s-au putut încărca mapările',
  'set.tf.archivedParen': ' (arhivat)',
  'set.tf.mappedCount': '{count} mapate',
  'set.tf.saveFirst': 'Salvați mai întâi câmpul pentru a configura mapările de opțiuni.',
  'set.tf.newField': '{type} nou',
  'set.tf.pageDescription': 'Gestionați definițiile câmpurilor importate, vizibilitatea, regulile de obligativitate și ordinea folosită de formularele de tichet.',
  'set.tf.addField': 'Adaugă câmp',
  'set.tf.addFieldHelp': 'Trageți un tip în lista de câmpuri sau folosiți Adaugă.',
  'set.tf.addType': 'Adaugă {type}',
  'set.tf.registry': 'Registrul de câmpuri',
  'set.tf.savingOrder': 'Se salvează ordinea…',
  'set.tf.searchAria': 'Caută câmpuri de tichet',
  'set.tf.searchPlaceholder': 'Caută după nume sau cheie...',
  'set.tf.filterAria': 'Filtrează după tipul câmpului',
  'set.tf.allTypes': 'Toate tipurile de câmpuri',
  'set.tf.emptyFirstTitle': 'Adăugați primul câmp de tichet',
  'set.tf.emptyFirstDesc': 'Trageți un tip de câmp din paletă sau folosiți Adaugă pentru a crea unul.',
  'set.tf.emptyFilterTitle': 'Niciun câmp nu corespunde acestor filtre',
  'set.tf.emptyFilterDesc': 'Încercați un alt termen de căutare sau extindeți filtrul pentru tipul câmpului.',
  'set.tf.archived': 'Arhivat',
  'set.tf.dependent': 'Dependent',
  'set.tf.customerVisible': 'Vizibil clientului',
  'set.tf.internal': 'Intern',
  'set.tf.configuration': 'Configurarea câmpului',
  'set.tf.selectTitle': 'Selectați un câmp de configurat',
  'set.tf.selectDesc': 'Alegeți un câmp din registru pentru a-i edita etichetele, regulile și vizibilitatea.',
  'set.tf.externalId': 'ID extern: {value}',
  'set.tf.sourceRenderer': 'Sursă: {source} · Randare: {renderer}',
  'set.tf.optionSource': 'Sursa opțiunilor: {value}',
  'set.tf.dependsOnKey': 'Depinde de: {value}',
  'set.tf.internalLabel': 'Etichetă internă',
  'set.tf.customerLabel': 'Etichetă pentru client',
  'set.tf.relationshipHelp': 'Determină de unde sunt preluate valorile de căutare la execuție.',
  'set.tf.validationVisibility': 'Validare și vizibilitate',
  'set.tf.requiredAgents': 'Obligatoriu pentru agenți',
  'set.tf.requiredCustomers': 'Obligatoriu pentru clienți',
  'set.tf.requiredClosure': 'Obligatoriu la închidere',
  'set.tf.displayedCustomers': 'Afișat clienților',
  'set.tf.customersEdit': 'Clienții pot edita',
  'set.tf.customersFilter': 'Clienții pot filtra',
  'set.tf.active': 'Activ',
  'set.tf.dropdownOptions': 'Opțiunile listei derulante ({count})',
  'set.tf.archiveTitle': 'Arhivați „{name}”?',
  'set.tf.archiveDesc': 'Câmpul va deveni inactiv și indisponibil pentru tichetele noi. Datele tichetelor existente sunt păstrate.',
  'set.tf.archiveField': 'Arhivează câmpul',
  'set.tf.alreadyArchived': 'Deja arhivat',
  'set.tf.archivedNote': 'Câmpurile arhivate rămân disponibile pentru valorile istorice.',
  'set.tfm.systemUser': 'Sistem',
  'set.tfm.untitled': 'Formular fără titlu',
  'set.tfm.pageDescription': 'Creați formulare reutilizabile și alegeți ce câmpuri importate pot folosi agenții și clienții.',
  'set.tfm.newForm': 'Formular nou',
  'set.tfm.creating': 'Se creează…',
  'set.tfm.allForms': 'Toate formularele',
  'set.tfm.configuredOne': '{count} formular configurat',
  'set.tfm.configuredMany': '{count} formulare configurate',
  'set.tfm.filter': 'Filtru',
  'set.tfm.searchAria': 'Caută formulare de tichet',
  'set.tfm.searchPlaceholder': 'Caută formulare…',
  'set.tfm.status': 'Stare',
  'set.tfm.allStatuses': 'Toate stările',
  'set.tfm.emptyFilterTitle': 'Niciun formular nu corespunde acestor filtre',
  'set.tfm.emptyFilterDesc': 'Încercați un alt termen de căutare sau extindeți filtrul de stare.',
  'set.tfm.emptyFirstTitle': 'Creați primul formular de tichet',
  'set.tfm.emptyFirstDesc': 'Creați un formular pentru a începe configurarea câmpurilor importate.',
  'set.tfm.createFirst': 'Creați primul formular',
  'set.tfm.colName': 'Nume',
  'set.tfm.colCreatedAt': 'Creat la',
  'set.tfm.colUpdatedBy': 'Ultima actualizare de',
  'set.tfm.colUpdatedAt': 'Ultima actualizare la',
  'set.tfm.colPortals': 'Portaluri asociate',
  'set.tfm.colActions': 'Acțiuni',
  'set.tfm.notConfigured': 'Neconfigurat',
  'set.tfm.actionsFor': 'Acțiuni pentru {name}',
  'set.tfm.editForm': 'Editează formularul',
  'set.tb.section.default.title': 'Câmpuri implicite',
  'set.tb.section.default.desc': 'Câmpurile de bază ale fluxului de asistență, importate din sistemul sursă.',
  'set.tb.section.custom.title': 'Câmpuri personalizate',
  'set.tb.section.custom.desc': 'Câmpuri suplimentare configurate pentru procesul dvs. de asistență.',
  'set.tb.section.nested.title': 'Câmpuri imbricate',
  'set.tb.section.nested.desc': 'Câmpuri dependente ale căror opțiuni urmează un câmp părinte.',
  'set.tb.discardTitle': 'Renunțați la modificările nesalvate?',
  'set.tb.discardDesc': 'Editările făcute acestui formular de tichet nu au fost salvate.',
  'set.tb.leave': 'Ieși fără salvare',
  'set.tb.nameRequired': 'Numele formularului este obligatoriu.',
  'set.tb.saved': 'Formular salvat.',
  'set.tb.nowPublished': 'Formular publicat.',
  'set.tb.nowUnpublished': 'Publicarea formularului a fost retrasă.',
  'set.tb.admin': 'Admin',
  'set.tb.builder': 'Generator',
  'set.tb.titleAria': 'Titlul formularului',
  'set.tb.defaultLocked': 'Implicit / blocat',
  'set.tb.previewPortal': 'Previzualizează în portal',
  'set.tb.configureTitle': 'Configurați câmpurile incluse în acest formular.',
  'set.tb.configureDesc': 'Modificările sunt salvate în baza de date a support desk-ului când selectați Salvează modificările. Câmpurile obligatorii rămân activate.',
  'set.tb.formDetails': 'Detalii formular',
  'set.tb.formDetailsHelp': 'Folosiți o descriere clară, astfel încât administratorii să știe când să folosească acest formular.',
  'set.tb.descPlaceholder': 'Descrieți când ar trebui folosit acest formular…',
  'set.tb.importedFields': 'Câmpuri importate',
  'set.tb.importedHelp': 'Trageți pentru a reordona câmpurile. Folosiți comutatorul pentru a include sau exclude un câmp din acest formular.',
  'set.tb.noneInSection': 'Niciun câmp importat în această secțiune.',
  'set.tb.dragReorder': 'Trageți pentru a reordona',
  'set.tb.required': 'Obligatoriu',
  'set.tb.nested': 'Imbricat',
  'set.tb.enableField': 'Activează {label}',
  'set.tb.enabled': 'Activat',
  'set.tb.disabled': 'Dezactivat',
  'set.tb.emptyTitle': 'Niciun câmp de configurat încă',
  'set.tb.emptyDesc': 'Importați câmpuri de tichet pentru a începe construirea acestui formular.',
  'set.tb.deleting': 'Se șterge…',
  'set.tp.loadError': 'Nu s-a putut încărca previzualizarea formularului.',
  'set.tp.preview': 'Previzualizare',
  'set.tp.customerPreview': 'Previzualizare pentru client',
  'set.tp.backToBuilder': 'Înapoi la generator',
  'set.tp.modeTitle': 'Mod previzualizare',
  'set.tp.modeDesc': 'Aceasta este o previzualizare fără trimitere. Toate câmpurile activate sunt afișate în ordinea formularului salvat.',
  'set.tp.emptyTitle': 'Niciun câmp nu este activat încă',
  'set.tp.emptyDesc': 'Activați câmpuri în generatorul de formulare pentru a le vedea în această previzualizare.',

  'por.error.generic': 'Nu s-a putut finaliza solicitarea.',
  'por.error.requestNotFound': 'Solicitarea nu a fost găsită.',
  'por.error.formUnavailable': 'Formularul de solicitare nu este disponibil.',
  'por.error.articleNotFound': 'Articolul nu a fost găsit.',
  'por.error.selectRating': 'Selectați o evaluare de la 1 la 5.',
  'por.tab.all': 'Toate',
  'por.list.title': 'Solicitările mele de asistență',
  'por.list.description': 'Urmăriți-vă solicitările și răspundeți echipei de asistență.',
  'por.list.newRequest': 'Solicitare nouă',
  'por.list.knowledgeBase': 'Bază de cunoștințe',
  'por.list.filterByStatus': 'Filtrează solicitările după stare',
  'por.list.searchPlaceholder': 'Caută după subiect…',
  'por.list.count': '{count} solicitări',
  'por.list.countOne': '{count} solicitare',
  'por.list.emptyFilteredTitle': 'Nicio solicitare nu corespunde acestei vizualizări',
  'por.list.emptyTitle': 'Nicio solicitare încă',
  'por.list.emptyFilteredDescription': 'Încercați fila Toate sau un alt termen de căutare.',
  'por.list.emptyDescription': 'Trimiteți o solicitare și echipa de asistență o va prelua.',
  'por.list.submitFirst': 'Trimiteți prima solicitare',
  'por.col.request': 'Solicitare',
  'por.col.subject': 'Subiect',
  'por.col.status': 'Stare',
  'por.col.priority': 'Prioritate',
  'por.col.created': 'Creat',
  'por.detail.myRequests': 'Solicitările mele',
  'por.detail.reopen': 'Redeschide această solicitare',
  'por.detail.attachments': 'Atașamente',
  'por.detail.download': 'Descarcă',
  'por.detail.conversation': 'Conversație',
  'por.detail.noReplies': 'Niciun răspuns încă',
  'por.detail.noRepliesHint': 'Adăugați un răspuns mai jos și echipa de asistență îl va prelua.',
  'por.detail.reply': 'Răspuns',
  'por.detail.replyPlaceholder': 'Scrieți un răspuns',
  'por.detail.sending': 'Se trimite…',
  'por.detail.sendReply': 'Trimite răspunsul',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Elimină {name}',
  'por.submit.newRequest': 'Solicitare nouă',
  'por.submit.defaultTitle': 'Trimiteți o solicitare de asistență',
  'por.submit.intro': 'Completați câmpurile de mai jos și trimiteți solicitarea.',
  'por.submit.subjectRequired': 'Subiectul este obligatoriu',
  'por.submit.descriptionRequired': 'Descrierea este obligatorie',
  'por.submit.attachments': 'Atașamente',
  'por.submit.submitting': 'Se trimite…',
  'por.submit.submit': 'Trimite solicitarea',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Bază de cunoștințe',
  'por.kb.description': 'Găsiți răspunsuri înainte de a trimite o solicitare.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Rezultatele căutării',
  'por.kb.searchPlaceholder': 'Caută articole',
  'por.kb.emptyTitle': 'Niciun articol publicat încă',
  'por.kb.emptyDescription': 'Trimiteți o solicitare și echipa de asistență vă va ajuta direct.',
  'por.kb.noFolders': 'Niciun folder',
  'por.kb.articles': '{count} articole',
  'por.kb.articlesOne': '{count} articol',
  'por.kb.noMatch': 'Niciun articol nu corespunde „{query}”',
  'por.kb.folderEmpty': 'Niciun articol în acest folder încă',
  'por.kb.noMatchHint': 'Încercați un termen de căutare mai scurt sau trimiteți o solicitare.',
  'por.kb.folderEmptyHint': 'Răsfoiți un alt folder sau trimiteți o solicitare.',
  'por.kb.submitRequest': 'Trimiteți o solicitare',
  'por.kb.views': '{count} vizualizări',
  'por.kb.thanks': 'Vă mulțumim pentru feedback!',
  'por.kb.helpful': 'A fost util?',
  'por.kb.yes': 'Da',
  'por.kb.no': 'Nu',
  'por.csat.thanksTitle': 'Vă mulțumim pentru feedback',
  'por.csat.thanksBody': 'Răspunsul dvs. a fost înregistrat.',
  'por.csat.title': 'Cum ne-am descurcat?',
  'por.csat.request': 'Solicitarea #{number}: {subject}',
  'por.csat.rating': 'Evaluare',
  'por.csat.stars': '{count} stele',
  'por.csat.comment': 'Comentariu',
  'por.csat.submit': 'Trimite feedback',
  'agents.tempPassword.title': 'Parolă temporară',
  'agents.tempPassword.help': 'Setați o parolă temporară pentru acest agent. La următoarea autentificare i se va cere să aleagă o parolă nouă. Cel puțin 12 caractere.',
  'agents.tempPassword.button': 'Setează parola temporară',
  'agents.tempPassword.saving': 'Se setează…',
  'agents.tempPassword.error': 'Parola temporară nu a putut fi setată.',
  'ui.showPassword': 'Afișează parola',
  'ui.hidePassword': 'Ascunde parola',
  'dashboard.awaitingResolutionConfirmation': 'În așteptarea confirmării rezolvării',
  'dashboard.awaitingUserReply': 'În așteptarea răspunsului utilizatorului',
  'dashboard.changeRequests': 'Cereri de modificare',
  'agents.tempPassword.successEmailed': 'Parola temporară a fost setată și trimisă prin e-mail agentului.',
  'agents.tempPassword.successNotEmailed': 'Parola temporară a fost setată, dar e-mailul nu a putut fi trimis. Transmiteți parola agentului printr-un canal securizat.',
} as const;

export default ro;
